import { withTheme } from 'emotion-theming';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var LoadingOutlineSmallIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M17.62 6.306L15.406 8.52a4.87 4.87 0 1 0 0 6.96l2.214 2.214a8 8 0 1 1 0-11.388z" }));
});

var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};

var getMediaQuery = function getMediaQuery(css, breakpoint) {
  return '@media (min-width: ' + breakpoint + ') { ' + css + ' }';
};

var breakpointAndUp = {};

var _loop = function _loop(_breakpoint2) {
  if (breakpoints[_breakpoint2] !== '0') {
    breakpointAndUp[_breakpoint2] = function (css) {
      return getMediaQuery(css, breakpoints[_breakpoint2]);
    };
  }
};

for (var _breakpoint2 in breakpoints) {
  _loop(_breakpoint2);
}

var theme = { baseFontSize: 16 }; //DEBTxCYBG pull this from theme component or global?
var baseSpacing = 8;

var spacingHelper = function spacingHelper(value) {
    var fontMultiple = value * baseSpacing;
    var rems = fontMultiple / theme.baseFontSize;
    return rems + 'rem';
};

var spacing = {
    EIGHTH: spacingHelper(0.125),
    QUARTER: spacingHelper(0.25),
    HALF: spacingHelper(0.5),
    THREE_QUARTERS: spacingHelper(0.75),
    SINGLE: spacingHelper(1),
    ONE_AND_QUARTER: spacingHelper(1.25),
    ONE_AND_HALF: spacingHelper(1.5),
    ONE_AND_THREE_QUARTERS: spacingHelper(1.75),
    DOUBLE: spacingHelper(2),
    TWO_AND_HALF: spacingHelper(2.5),
    TRIPLE: spacingHelper(3),
    THREE_AND_HALF: spacingHelper(3.5),
    QUADRUPLE: spacingHelper(4),
    QUINTUPLE: spacingHelper(5),
    SEXTUPLE: spacingHelper(6),
    SEPTUPLE: spacingHelper(7),
    OCTUPLE: spacingHelper(8),
    NONUPLE: spacingHelper(9),
    DECUPLE: spacingHelper(10)
};

var externalMarginRegular = '\n    margin-right: ' + spacing.DOUBLE + ';\n    margin-bottom: ' + spacing.DOUBLE + ';\n';

var internalPaddingShell = '\n    overflow: auto;\n    padding-bottom: ' + spacing.SINGLE + '; \n    padding-left: ' + spacing.DOUBLE + '; \n    padding-right: 0; \n    padding-top: ' + spacing.DOUBLE + ';\n    ' + breakpointAndUp.md1('\n        padding-left: ' + spacing.TRIPLE + ';\n        padding-right: ' + spacing.SINGLE + ';\n    ') + '\n';

/* Font size config: usage example ${fontSize('arran')} */

var fontConfig = {
  lewis: {
    xs1: { fontSize: 37, lineHeight: 1.189 },
    sm1: { fontSize: 37, lineHeight: 1.189 },
    md1: { fontSize: 45, lineHeight: 1.067 },
    lg1: { fontSize: 52, lineHeight: 1.154 },
    xl1: { fontSize: 52, lineHeight: 1.154 }
  },
  skye: {
    xs1: { fontSize: 32, lineHeight: 1.125 },
    sm1: { fontSize: 32, lineHeight: 1.125 },
    md1: { fontSize: 40, lineHeight: 1.1 },
    lg1: { fontSize: 45, lineHeight: 1.156 },
    xl1: { fontSize: 45, lineHeight: 1.156 }
  },
  shetland: {
    xs1: { fontSize: 29, lineHeight: 1.241 },
    sm1: { fontSize: 29, lineHeight: 1.241 },
    md1: { fontSize: 34, lineHeight: 1.176 },
    lg1: { fontSize: 39, lineHeight: 1.128 },
    xl1: { fontSize: 39, lineHeight: 1.128 }
  },
  mull: {
    xs1: { fontSize: 26, lineHeight: 1.231 },
    sm1: { fontSize: 26, lineHeight: 1.231 },
    md1: { fontSize: 29, lineHeight: 1.241 },
    lg1: { fontSize: 33, lineHeight: 1.212 },
    xl1: { fontSize: 33, lineHeight: 1.212 }
  },
  islay: {
    xs1: { fontSize: 23, lineHeight: 1.217 },
    sm1: { fontSize: 23, lineHeight: 1.217 },
    md1: { fontSize: 25, lineHeight: 1.28 },
    lg1: { fontSize: 28, lineHeight: 1.286 },
    xl1: { fontSize: 28, lineHeight: 1.286 }
  },
  orkney: {
    xs1: { fontSize: 20, lineHeight: 1.4 },
    sm1: { fontSize: 20, lineHeight: 1.4 },
    md1: { fontSize: 22, lineHeight: 1.273 },
    lg1: { fontSize: 25, lineHeight: 1.28 },
    xl1: { fontSize: 25, lineHeight: 1.28 }
  },
  arran: {
    xs1: { fontSize: 18, lineHeight: 1.333 },
    sm1: { fontSize: 18, lineHeight: 1.333 },
    md1: { fontSize: 19, lineHeight: 1.474 },
    lg1: { fontSize: 21, lineHeight: 1.333 },
    xl1: { fontSize: 21, lineHeight: 1.333 }
  },
  jura: {
    xs1: { fontSize: 16, lineHeight: 1.5 },
    sm1: { fontSize: 16, lineHeight: 1.5 },
    md1: { fontSize: 16, lineHeight: 1.5 },
    lg1: { fontSize: 18, lineHeight: 1.556 },
    xl1: { fontSize: 18, lineHeight: 1.556 }
  },
  uist: {
    xs1: { fontSize: 14, lineHeight: 1.429 },
    sm1: { fontSize: 14, lineHeight: 1.429 },
    md1: { fontSize: 14, lineHeight: 1.429 },
    lg1: { fontSize: 16, lineHeight: 1.5 },
    xl1: { fontSize: 16, lineHeight: 1.5 }
  },
  bute: {
    xs1: { fontSize: 12, lineHeight: 1.333 },
    sm1: { fontSize: 12, lineHeight: 1.333 },
    md1: { fontSize: 13, lineHeight: 1.538 },
    lg1: { fontSize: 13, lineHeight: 1.538 },
    xl1: { fontSize: 13, lineHeight: 1.538 }
  },
  cumbrae: {
    xs1: { fontSize: 11, lineHeight: 1.455 },
    sm1: { fontSize: 11, lineHeight: 1.455 },
    md1: { fontSize: 12, lineHeight: 1.333 },
    lg1: { fontSize: 12, lineHeight: 1.333 },
    xl1: { fontSize: 12, lineHeight: 1.333 }
  }
};

var generateSASS = function generateSASS(mqBreakpoint, size, lineHeight) {
  var styles = '';
  if (parseInt(mqBreakpoint) === 0) {
    styles = 'font-size: ' + size + 'px; line-height: ' + lineHeight + ';';
  } else {
    styles = '\n      @media (min-width: ' + mqBreakpoint + ') {\n        font-size: ' + size + 'px;\n        line-height: ' + lineHeight + ';\n      } \n    ';
  }
  return styles;
};

var fontSizes = {};

for (var _fontSize in fontConfig) {
  if (fontConfig.hasOwnProperty(_fontSize)) {
    var style = '';
    for (var breakpoint in fontConfig[_fontSize]) {
      if (fontConfig[_fontSize].hasOwnProperty(breakpoint)) {
        var _fontConfig$_fontSize = fontConfig[_fontSize][breakpoint],
            size = _fontConfig$_fontSize.fontSize,
            lineHeight = _fontConfig$_fontSize.lineHeight;

        style += generateSASS(breakpoints[breakpoint], size, lineHeight);
      }
    }
    fontSizes[_fontSize] = style;
  }
}

var fontSize = function fontSize(font) {
  return fontSizes[font];
};

var useFontSize = {

  of: {
    lewis: function lewis() {
      return fontSizes['lewis'];
    },
    skye: function skye() {
      return fontSizes['skye'];
    },
    shetland: function shetland() {
      return fontSizes['shetland'];
    },
    mull: function mull() {
      return fontSizes['mull'];
    },
    islay: function islay() {
      return fontSizes['islay'];
    },
    orkney: function orkney() {
      return fontSizes['orkney'];
    },
    arran: function arran() {
      return fontSizes['arran'];
    },
    jura: function jura() {
      return fontSizes['jura'];
    },
    uist: function uist() {
      return fontSizes['uist'];
    },
    bute: function bute() {
      return fontSizes['bute'];
    },
    cumbrae: function cumbrae() {
      return fontSizes['cumbrae'];
    }
  },

  biggerThan: {
    lewis: function lewis() {
      throw new Error("lewis is the biggest font");
    },
    skye: function skye() {
      return fontSizes['lewis'];
    },
    shetland: function shetland() {
      return fontSizes['skye'];
    },
    mull: function mull() {
      return fontSizes['shetland'];
    },
    islay: function islay() {
      return fontSizes['mull'];
    },
    orkney: function orkney() {
      return fontSizes['islay'];
    },
    arran: function arran() {
      return fontSizes['orkney'];
    },
    jura: function jura() {
      return fontSizes['arran'];
    },
    uist: function uist() {
      return fontSizes['jura'];
    },
    bute: function bute() {
      return fontSizes['uist'];
    },
    cumbrae: function cumbrae() {
      return fontSizes['bute'];
    }
  },

  smallerThan: {
    lewis: function lewis() {
      return fontSizes['skye'];
    },
    skye: function skye() {
      return fontSizes['shetland'];
    },
    shetland: function shetland() {
      return fontSizes['mull'];
    },
    mull: function mull() {
      return fontSizes['islay'];
    },
    islay: function islay() {
      return fontSizes['orkney'];
    },
    orkney: function orkney() {
      return fontSizes['arran'];
    },
    arran: function arran() {
      return fontSizes['jura'];
    },
    jura: function jura() {
      return fontSizes['uist'];
    },
    uist: function uist() {
      return fontSizes['bute'];
    },
    bute: function bute() {
      return fontSizes['cumbrae'];
    },
    cumbrae: function cumbrae() {
      throw new Error("cumbrae is the smallest font");
    }
  }
};

var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
	nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
  __proto__: null,
  caches: caches,
  css: css,
  cx: cx,
  flush: flush,
  getRegisteredStyles: getRegisteredStyles,
  hydrate: hydrate,
  injectGlobal: injectGlobal,
  keyframes: keyframes,
  merge: merge,
  sheet: sheet
});

var styled = createEmotionStyled(emotion, React);

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var HSL_SLICE_START = 4;
var DEFAULT_AMOUNT = 5;

var hslAdjust = function hslAdjust(hslText) {
	var splitHSL = hslText.slice(HSL_SLICE_START, hslText.length - 1).split(',');

	var _splitHSL = slicedToArray(splitHSL, 3),
	    hueLabel = _splitHSL[0],
	    saturationLabel = _splitHSL[1],
	    lightnessLabel = _splitHSL[2];

	var hue = parseInt(hueLabel, 10);
	var saturation = parseInt(saturationLabel.slice(0, saturationLabel.length - 1), 10);
	var lightness = parseInt(lightnessLabel.slice(0, lightnessLabel.length - 1), 10);

	return {
		darken: function darken() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness - amount) + '%)';
		},
		lighten: function lighten() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness + amount) + '%)';
		},
		saturate: function saturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation + amount) + '%, ' + lightness + '%)';
		},
		desaturate: function desaturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation - amount) + '%, ' + lightness + '%)';
		}
	};
};

var _templateObject = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n']),
    _templateObject2 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n']),
    _templateObject3 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n']),
    _templateObject4 = taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n'], ['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n']),
    _templateObject5 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n'], ['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n']),
    _templateObject6 = taggedTemplateLiteral(['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n'], ['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n']),
    _templateObject7 = taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n'], ['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject8 = taggedTemplateLiteral(['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n']);

var circularPulseB = keyframes(_templateObject, spacing.QUADRUPLE);

var circularPulseCB = keyframes(_templateObject2, spacing.QUADRUPLE);

var circularPulseYB = keyframes(_templateObject3, spacing.QUADRUPLE);

var fadeIn = keyframes(_templateObject4);

var fadeOut = keyframes(_templateObject5);

var iconPulse = function iconPulse(colour) {
  return keyframes(_templateObject6, colour, hslAdjust(colour).lighten(0.2));
};

var rotate = keyframes(_templateObject7);

var scaleFadeIn = keyframes(_templateObject8);

var animations = {
  circularPulseB: circularPulseB,
  circularPulseCB: circularPulseCB,
  circularPulseYB: circularPulseYB,
  fadeIn: fadeIn,
  fadeOut: fadeOut,
  iconPulse: iconPulse,
  rotate: rotate,
  scaleFadeIn: scaleFadeIn
};

var generalPalette = {
  black: 'hsl(0, 0%, 0%)',
  blue: 'hsl(204, 52%, 48%)',
  blueLight: 'hsl(208, 59%, 60%)',
  green: 'hsl(135, 41%, 48%)',
  greenFaint: 'hsl(135, 41%, 70%)',
  greyDarkest: 'hsl(0, 0%, 28%)',
  greyDarker: 'hsl(0, 0%, 45%)',
  grey: 'hsl(0, 0%, 60%)',
  greyLighter: 'hsl(0, 0%, 75%)',
  greyLightest: 'hsl(0, 0%, 85%)',
  orange: 'hsl(29, 77%, 56%)',
  red: 'hsl(8, 52%, 50%)',
  purple: 'hsl(282, 25%, 57%)',
  white: 'hsl(0, 0%, 100%)'
};

var black = generalPalette.black,
    blue = generalPalette.blue,
    blueLight = generalPalette.blueLight,
    green = generalPalette.green,
    greenFaint = generalPalette.greenFaint,
    greyDarker = generalPalette.greyDarker,
    greyDarkest = generalPalette.greyDarkest,
    greyLightest = generalPalette.greyLightest,
    orange = generalPalette.orange,
    red = generalPalette.red,
    grey = generalPalette.grey,
    greyLighter = generalPalette.greyLighter,
    purple = generalPalette.purple,
    white = generalPalette.white;


var colours = {
  backgrounds: {
    alternateBody: 'hsl(212, 100%, 97%)',
    alternateHeader: greyLightest,
    component: white,
    modalBackdrop: black,
    modalBackdropOpaque: 'rgba(0, 0, 0, 0.8)',
    shell: 'hsl(0, 0%, 95.3%)',
    tableCell: 'hsl(0, 0%, 97%)',
    tableCellAlternate: 'hsl(0, 71%, 97%)',
    tableCellHeader: 'hsl(0, 0%, 94%)'
  },
  component: {
    border: greyLightest,
    focusOutline: 'hsl(208, 59%, 60%)',
    hover: greyLightest,
    locked: greyDarker,
    frame: {
      active: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 0%, 85%),' + 'hsl(45, 0%, 85%) 28px, hsl(46, 0%, 95%) 28px, hsl(46, 0%, 95%) 56px)',
        content: 'hsl(45, 0%, 85%)',
        contentAlternate: 'hsl(46, 0%, 95%)'
      },
      bespoke: {
        background: 'repeating-linear-gradient(45deg, hsl(302, 44%, 70%), ' + 'hsl(302, 44%, 70%) 28px, hsl(302, 44%, 90%) 28px, hsl(302, 44%, 90%) 56px)',
        content: 'hsl(302, 44%, 70%)',
        contentAlternate: 'hsl(302, 44%, 90%)'
      },
      deprecated: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 100%, 46%), ' + 'hsl(45, 100%, 46%) 28px, hsl(46, 100%, 64%) 28px, hsl(46, 100%, 64%) 56px)',
        content: 'hsl(45, 100%, 46%)',
        contentAlternate: 'hsl(46, 100%, 64%)'
      },
      draft: {
        background: 'repeating-linear-gradient(45deg, hsl(204, 52%, 48%), ' + 'hsl(204, 52%, 48%) 28px, hsl(205, 52%, 58%) 28px, hsl(205, 52%, 58%) 56px)',
        content: 'hsl(204, 52%, 48%)',
        contentAlternate: 'hsl(205, 52%, 58%)'
      },
      outdated: {
        background: 'repeating-linear-gradient(45deg, hsl(269, 69%, 69%), ' + 'hsl(269, 69%, 69%) 28px, hsl(270, 69%, 79%) 28px, hsl(270, 69%, 79%) 56px)',
        content: 'hsl(269, 69%, 69%)',
        contentAlternate: 'hsl(270, 69%, 79%)'
      }
    }
  },
  disabled: {
    background: greyLightest,
    border: greyDarkest
  },
  neutral: {
    black: black,
    grey: grey,
    greyDarker: greyDarker,
    greyDarkest: greyDarkest,
    greyLighter: greyLighter,
    greyLightest: greyLightest,
    white: white
  },
  telephony: {
    answerCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    calledGradient: 'linear-gradient(hsl(159, 52%, 67%), hsl(153, 41%, 49%));',
    conferenceCallGradient: 'linear-gradient(hsl(193, 100%, 91%), hsl(196, 96%, 80%));',
    conferenceMaskGradient: 'linear-gradient(hsl(248, 86%, 83%), hsl(260, 94%, 72%));',
    dialingCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    holdCallGradient: 'linear-gradient(hsl(45, 95%, 75%), hsl(37, 91%, 65%));',
    makeCallGradient: 'linear-gradient(hsl(33, 15%, 86%), hsl(180, 3%, 69%));',
    onCallGradient: 'linear-gradient(hsl(129, 80%, 82%), hsl(127, 67%, 63%));',
    answerCall: 'hsl(89, 91%, 40%)',
    closeCall: 'hsl(353, 98%, 41%)',
    dialCall: 'hsl(89, 91%, 40%)',
    endCall: 'hsl(353, 98%, 41%)',
    holdCall: 'hsl(37, 94%, 49%)',
    resumeCall: 'hsl(89, 91%, 40%)'
  },
  typography: {
    body: greyDarkest,
    secondaryBody: greyDarker,
    supplementaryBody: grey
  },
  utility: {
    active: green,
    archived: greyLightest,
    blocker: 'hsl(0, 60%, 96%)',
    empty: 'hsl(0, 0%, 100%)',
    emptyBorder: 'hsl(0, 0%, 40%)',
    error: red,
    errorBodyBackground: 'hsl(8,52%,96%)',
    focus: blueLight,
    help: 'hsl(210, 38%, 91%)',
    inactive: red,
    indicative: orange,
    information: blue,
    notStarted: greyDarker,
    off: grey,
    offDisabled: greyLighter,
    ongoing: purple,
    paused: blue,
    pending: orange,
    success: green,
    successDisabled: greenFaint,
    warning: orange
  },
  utilityLegacy: {
    infoBackground: 'hsl(210, 46%, 91%)',
    infoBorder: 'hsl(204, 52%, 48%)',
    noteBackground: 'hsl(45, 53%, 94%)',
    noteBorder: 'hsl(46, 88%, 24%)',
    tipBackground: 'hsl(125, 21%, 88%)',
    tipBorder: 'hsl(135, 41%, 48%)',
    warningBackground: 'hsl(0, 60%, 96%)',
    warningBorder: 'hsl(8, 52%, 50%)'
  },
  // TODOxVM: Colours are getting a proper revisit soon. This is temporary. 
  utilitySupremacy: {
    errorPrimary: 'hsl(0, 93%, 41%)',
    errorSecondary: 'hsl(0, 96%, 77%)',
    errorTertiary: 'hsl(0, 60%, 96%)',
    guidancePrimary: 'hsl(210, 97%, 87%)',
    guidanceSecondary: 'hsl(210, 100%, 95%)',
    rememberPrimary: 'hsl(55, 92%, 69%)',
    rememberSecondary: 'hsl(55, 100%, 88%)',
    successPrimary: 'hsl(144, 83%, 25%)',
    successSecondary: 'hsl(90, 91%, 88%)',
    tipPrimary: 'hsl(90, 53%, 70%)',
    tipSecondary: 'hsl(90, 61%, 88%)'
  }
};

var getThemeIcon = function getThemeIcon(vmIcon, generalIcon) {
  return function (themeName) {
    return themeName === 'vm' ? vmIcon : generalIcon;
  };
};

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React.createElement("svg", _extends$2({ width: "16", height: "16", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M29.9 29.901a4.103 4.103 0 0 0 0 5.803l12.294 12.294L29.9 60.3a4.102 4.102 0 0 0 5.803 5.8l12.294-12.296 12.3 12.296a4.103 4.103 0 1 0 5.803-5.803L53.8 47.993l12.296-12.298a4.1 4.1 0 0 0 .002-5.797 4.095 4.095 0 0 0-5.792-.001L48.007 42.196 35.704 29.9a4.104 4.104 0 0 0-5.803.001z" }), React.createElement("path", { d: "M48 0c26.508 0 48 21.492 48 48.003s-21.492 48-48 48c-26.511 0-48-21.489-48-48S21.489 0 48 0zm0 90.003c23.193 0 42-18.804 42-42 0-23.193-18.807-42-42-42-23.196 0-42 18.807-42 42 0 23.196 18.804 42 42 42z" }));
});

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2(_ref, ["styles"]);

  return React.createElement("svg", _extends$3({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M87.887 21.656c12.578 18.847 10.243 43.892-5.516 60.086l-.482.488a47.852 47.852 0 0 1-33.941 14.035C25.06 96.25 5.37 80.068.92 57.618S8.498 12.699 29.648 3.953c21.15-8.746 45.534-1.334 58.239 17.703zM47.947 8.308c-19.072.014-35.48 13.499-39.188 32.207-3.708 18.71 6.316 37.432 23.941 44.72 17.626 7.288 37.945 1.111 48.532-14.754 10.587-15.864 8.494-36.998-5-50.478A39.88 39.88 0 0 0 47.949 8.308zM62.09 28.49l5.656 5.656-14.143 14.142 14.143 14.143-5.656 5.656-14.143-14.143-14.142 14.143-5.656-5.656L42.29 48.288 28.149 34.146l5.656-5.656 14.142 14.142z" }));
});

var getCrossOutlineLarge = getThemeIcon(VMIcon, GenericIcon);

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3(_ref, ["styles"]);

  return React.createElement("svg", _extends$4({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon download"), React.createElement("path", { d: "M4 24h24v-6h4v10H0V18h4v6zm14-8.343l4.01-4.01 2.828 2.828-8.84 8.84-8.838-8.84 2.828-2.828 4.01 4.01V2h4v13.657z" }));
});

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4(_ref, ["styles"]);

  return React.createElement("svg", _extends$5({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M12.698 66.879v16.695h66.783V66.88h8.348v25.043H4.35V66.88zM68.696 0c8.068 0 14.608 6.54 14.608 14.609 0 8.068-6.54 14.608-14.608 14.608a51.88 51.88 0 0 1-15.265-2.274 57.795 57.795 0 0 0-3.518 19.812V65.2l7.63-7.63 5.902 5.903-17.706 17.705-17.706-17.705 5.902-5.902 7.63 7.629V46.755a66.147 66.147 0 0 1 4.097-22.865L10.567 7.904 14.03.306l35.006 15.947a65.712 65.712 0 0 1 7.002-10.77A14.543 14.543 0 0 1 67.45 0zm0 8.348h-1.248a6.226 6.226 0 0 0-4.887 2.35 56.93 56.93 0 0 0-5.67 8.56 43.6 43.6 0 0 0 11.805 1.612 6.26 6.26 0 0 0 0-12.522z" }));
});

var getDownloadSolidLarge = getThemeIcon(VMIcon$1, GenericIcon$1);

var _extends$6 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5(_ref, ["styles"]);

  return React.createElement("svg", _extends$6({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon magnify"), React.createElement("path", { d: "M31.28 27.07l-7.653-7.653a12.46 12.46 0 0 0 1.82-6.5C25.446 5.994 19.448 0 12.526 0 5.608-.002 0 5.608 0 12.53c0 6.918 5.996 12.915 12.915 12.915 2.303 0 4.456-.626 6.31-1.71l7.693 7.7c.753.75 1.975.75 2.726 0l1.91-1.91c.75-.752.478-1.702-.273-2.454zM3.857 12.53c0-4.793 3.883-8.676 8.673-8.676s9.06 4.267 9.06 9.06a8.677 8.677 0 0 1-8.675 8.676c-4.792-.002-9.06-4.27-9.06-9.06z" }));
});

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6(_ref, ["styles"]);

  return React.createElement("svg", _extends$7({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M85.656 91.906L62.21 68.461c-14.132 11.337-34.364 10.89-47.982-1.06a36.96 36.96 0 0 1 4.545-58.424A36.934 36.934 0 0 1 75.847 39.95h-7.385c-.001-13.563-9.24-25.383-22.402-28.66-13.162-3.277-26.864 2.83-33.225 14.81-6.361 11.98-3.747 26.752 6.34 35.82 10.692 9.33 26.47 9.86 37.763 1.27l-2.666-2.669c-4.491-4.504-4.491-11.793 0-16.298 4.56-4.354 11.739-4.354 16.3 0 4.5 4.501 4.5 11.797 0 16.298l-2.93 2.928 23.236 23.236zM62.421 48.229a4.143 4.143 0 0 0-2.926 7.071l2.926 2.928 2.928-2.928a4.143 4.143 0 0 0-2.928-7.07z" }));
});

var getMagnifySolidLarge = getThemeIcon(VMIcon$2, GenericIcon$2);

var _extends$8 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7(_ref, ["styles"]);

  return React.createElement("svg", _extends$8({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M14.873 1.126C13.563-.187 12.577.01 12.577.01L.917 11.672 0 16l4.33-.918L15.99 3.423c-.001 0 .196-.984-1.116-2.297h-.001zm-10.8 13.436l-1.477.317a3.387 3.387 0 0 0-.627-.847 3.379 3.379 0 0 0-.848-.629l.318-1.475.427-.426s.803.017 1.71.925c.906.905.924 1.71.924 1.71l-.427.426v-.001z" }));
});

var _extends$9 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$8(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$8(_ref, ["styles"]);

  return React.createElement("svg", _extends$9({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M76.424 1.155l4.001 2.824a6.3 6.3 0 0 1 1.515 8.767L77.7 18.758l-6.278-4.426 3.443-4.878-1.74-1.226-4.054 5.744 5.876 4.148a6.3 6.3 0 0 1 1.519 8.767L43.817 71.393l-6.194-4.546L69.366 23.58l-6.858-4.837a5.062 5.062 0 0 1-1.504-1.676 7.37 7.37 0 0 1-1.354 3.873L23.114 71.141l-1.19 11.156 9.63-5.677-4.923-3.578 4.515-6.21 11.059 8.033-5.603 7.924-15.25 8.658a4.505 4.505 0 0 1-2.51.736 5.202 5.202 0 0 1-2.985-.953 5.03 5.03 0 0 1-2.07-5.021l1.91-17.925L33.5 43.823c-.684.378-1.395.708-2.126.986l-1.879.712-2.73-7.177 1.883-.716a8.346 8.346 0 0 0 5.04-5.333l4.406-11.891A19.016 19.016 0 0 1 49.401 9.068a9.418 9.418 0 0 1 8.61 1.608 7.257 7.257 0 0 1 2.426 3.067 5.03 5.03 0 0 1 .844-2.058l6.368-9.022a6.293 6.293 0 0 1 8.775-1.508zm-24.18 15.184a2.813 2.813 0 0 0-.743.116 11.677 11.677 0 0 0-6.206 6.619L41.86 32.34 53.25 16.691a1.588 1.588 0 0 0-1.005-.352z" }));
});

var getPencilOutlineLarge = getThemeIcon(VMIcon$3, GenericIcon$3);

var _extends$a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$9(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$4 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$9(_ref, ["styles"]);

  return React.createElement("svg", _extends$a({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7 7V4h2v3h3v2H9v3H7V9H4V7h3zm1 9A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14z" }));
});

var _extends$b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$a(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$4 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$a(_ref, ["styles"]);

  return React.createElement("svg", _extends$b({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 0c26.51 0 48 21.49 48 48-.03 26.497-21.503 47.97-48 48C21.49 96 0 74.51 0 48S21.49 0 48 0zm0 8C25.909 8 8 25.909 8 48s17.909 40 40 40 40-17.909 40-40C87.975 25.919 70.081 8.025 48 8zm4 16v20h20v8H52v20h-8V52H24v-8h20V24z" }));
});

var getPlusOutlineLarge = getThemeIcon(VMIcon$4, GenericIcon$4);

var _extends$c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$b(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$5 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$b(_ref, ["styles"]);

  return React.createElement("svg", _extends$c({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M18 29.998a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm72 39.001a3.002 3.002 0 0 1-3 3.003H72V54H24v18.003H9c-1.656 0-3-1.344-3-3.003V27.001a3 3 0 0 1 3-3.003h78A3 3 0 0 1 90 27v41.998zM30 90h36V60H30v30zm0-71.998h36V5.997H30v12.004zm63 0H72V0H24v18H3c-1.656 0-3 1.342-3 2.998v54.001a3.004 3.004 0 0 0 3 3.003h21V96h48V78.002h21c1.656 0 3-1.347 3-3.003V20.998A2.999 2.999 0 0 0 93 18zM36 29.998a6 6 0 1 0 0 12 6 6 0 0 0 0-12z", fillRule: "evenodd" }));
});

var _extends$d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$c(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$5 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$c(_ref, ["styles"]);

  return React.createElement("svg", _extends$d({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M90.379 20H96v56H84v-8h4V28.05a47.653 47.653 0 0 0-9.086 1.266c2 2.156 3.104 4.993 3.086 7.934.14 5.099-3.04 9.7-7.86 11.371A12.031 12.031 0 0 1 58 37.328a11.427 11.427 0 0 1 3.055-7.98A48.473 48.473 0 0 0 49.545 28H8v40h8V52h64v44H16V80.008h8V88h48V60H24v16H0V20h49.545a54.464 54.464 0 0 1 20.416 3.824A53.677 53.677 0 0 1 90.379 20zM69.992 32.605c-3.285 1.73-4 3.118-3.992 4.704a4.023 4.023 0 0 0 1.684 3.28 4.113 4.113 0 0 0 3.845.47A3.758 3.758 0 0 0 74 37.312c-.012-1.648-.72-3.003-4.008-4.707zM72 0a8.01 8.01 0 0 1 8 8v8h-8V8H24v8h-8V8a8.01 8.01 0 0 1 8-8z" }));
});

var getPrinterOutlineLarge = getThemeIcon(VMIcon$5, GenericIcon$5);

var _extends$e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$d(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$6 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$d(_ref, ["styles"]);

  return React.createElement("svg", _extends$e({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M64 74.5h.667v-.03C77.663 73.826 89 67 89 50c0-11.17-7-20-20-21 0-10-6-21-21-21-14 0-22 12-21 24-12 0-20 8.21-20 19 0 16 10.558 22.598 22.667 23.442v.058H32V81h-6v-.07C11.47 79.904 0 67.792 0 53c0-13.113 9.014-24.12 21.183-27.164C22.75 12.415 34.16 2 48 2c12.869 0 23.635 9.003 26.343 21.054C86.828 26.489 96 37.924 96 51.5c0 15.79-12.405 28.681-28 29.463V81h-4z" }), React.createElement("path", { d: "M45 47.743L32.282 60.46a3 3 0 1 1-4.242-4.242L45.718 38.54A2.992 2.992 0 0 1 48 37.665a2.992 2.992 0 0 1 2.282.875L67.96 56.218a3 3 0 1 1-4.242 4.242L51 47.743V90a3 3 0 0 1-6 0z" }));
});

var _extends$f = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$e(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$6 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$e(_ref, ["styles"]);

  return React.createElement("svg", _extends$f({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M74.696 21.579c10.785 1.88 18.337 11.702 17.384 22.608-.952 10.907-10.092 19.27-21.04 19.253H60.416a46.66 46.66 0 0 0-10.496 1.057V80.72c-.009 7.419-6.021 13.431-13.44 13.44a13.44 13.44 0 0 1-9.799-22.639A40.06 40.06 0 0 1 42.24 58.932v-17.6l-7.02 7.02-5.43-5.43 16.29-16.288 16.29 16.289-5.43 5.43-7.02-7.02v15.32a57.903 57.903 0 0 1 10.481-.893H71.04c7.294.017 13.263-5.799 13.435-13.09.173-7.292-5.515-13.384-12.801-13.711a3.84 3.84 0 0 1-3.503-2.753C64.935 15.221 54.12 8.281 42.784 9.916 31.45 11.554 23.038 21.269 23.04 32.72c0 1.079-.44 2.11-1.219 2.857a3.697 3.697 0 0 1-2.887 1.07 9.394 9.394 0 0 1-.653-.072h-.026a9.592 9.592 0 1 0-.004 19.185h4.789v7.68h-4.789c-9.025 0-16.53-6.945-17.228-15.943-.698-8.998 5.645-17.018 14.562-18.41C17.247 15.088 28.225 4.02 42.208 2.244 56.192.469 69.588 8.44 74.696 21.579zM42.24 67.56a37.242 37.242 0 0 0-9.769 9 5.98 5.98 0 0 0-1.751 4.159 5.76 5.76 0 1 0 11.52 0z" }));
});

var getUpload = getThemeIcon(VMIcon$6, GenericIcon$6);

// Note this is a copy paste of the String Utils within the library.

var addFullStop = function addFullStop(value) {
	return value.charAt(value.length - 1) === '.' ? value : value.replace(/([^.])$/, '$1.');
};

var capitaliseFirstLetter = function capitaliseFirstLetter(value) {
	return value.trim().charAt(0).toUpperCase() + value.trim().slice(1);
};

var pascalCaseString = function pascalCaseString(value) {
	return value.split(" ").map(function (word) {
		return capitaliseFirstLetter(word);
	}).join(" ");
};

var lowercaseFirstLetter = function lowercaseFirstLetter(value) {
	return value.charAt(0).toLowerCase() + value.slice(1);
};

var stringHelpers = { addFullStop: addFullStop, capitaliseFirstLetter: capitaliseFirstLetter, lowercaseFirstLetter: lowercaseFirstLetter, pascalCaseString: pascalCaseString };
var stringHelpers_2 = stringHelpers.capitaliseFirstLetter;

var styleGuideTheme = {
	borderRadius: spacing.HALF,
	boxShadow: '0 0 4px 1px hsla(0, 0%, 0%, 0.3)',
	internalPaddingRegular: '\n\t\tpadding-left: ' + spacing.DOUBLE + ';\n\t\tpadding-top: ' + spacing.DOUBLE + ';\n\n\t\t@media (max-width: ' + breakpoints.md1 + ') {\n\t\t\tpadding-left: ' + spacing.SINGLE + ';\n\t\t\tpadding-top: ' + spacing.SINGLE + ';\n\t\t}\n\t',
	internalPaddingFull: '\n\tpadding: ' + spacing.DOUBLE + ';\n\n\t@media (max-width: ' + breakpoints.md1 + ') {\n\t\tpadding: ' + spacing.SINGLE + ';\n\t}\n',
	externalMarginRegular: '\n\t\tmargin-right: ' + spacing.DOUBLE + ';\n\t\tmargin-bottom: ' + spacing.DOUBLE + ';\n\n\t\t@media (max-width: ' + breakpoints.md1 + ') {\n\t\t\tmargin-right: ' + spacing.SINGLE + ';\n\t\t\tmargin-bottom: ' + spacing.SINGLE + ';\n\t\t}\n\t',
	focus: '\n\t\t:focus {\n\t\t\tbox-shadow: 0 0 0 2px hsl(208, 59%, 60%);\n\t\t\toutline: 0;\n\t\t}\n\t',
	focusInset: '\n\t\t:focus {\n\t\t\tbox-shadow: inset 0 0 0 2px hsl(208, 59%, 60%);\n\t\t\toutline: 0;\n\t\t}\n',
	colours: {
		backgrounds: {
			alternative: 'hsl(0, 0%, 20%)',
			button: {
				active: 'linear-gradient(to top, hsl(0, 0%, 0%), hsl(0, 0%, 5%))',
				hover: 'hsl(0, 0%, 30%)',
				primary: 'linear-gradient(to top, hsl(0, 0%, 5%), hsl(0, 0%, 10%))'
			},
			deprecated: 'repeating-linear-gradient(45deg, hsl(45, 100%, 51%), ' + 'hsl(45, 100%, 51%) 28px, hsl(46, 100%, 64%) 28px, hsl(46, 100%, 64%) 56px)',
			main: 'hsl(0, 0%, 0%)',
			notes: 'hsl(194, 61%, 97%)',
			outdated: 'repeating-linear-gradient(45deg, hsl(269, 69%, 69%), ' + 'hsl(269, 69%, 69%) 28px, hsl(270, 69%, 79%) 28px, hsl(270, 69%, 79%) 56px)',
			page: 'hsl(0, 0%, 25%)'
		},
		body: {
			disabled: 'hsl(0, 0%, 70%)',
			light: 'hsl(0, 0%, 100%)',
			notes: 'hsl(194, 61%, 40%)',
			placeholder: 'hsl(0, 0%, 50%)'
		},
		code: {
			blue: 'hsl(198, 95%, 47%)',
			blueLight: 'hsl(199, 98%, 71%)',
			green: 'hsl(103, 64%, 55%)',
			orange: 'hsl(22, 80%, 55%)',
			pink: 'hsl(312, 84%, 66%)',
			purple: 'hsl(279, 75%, 35%)',
			red: 'hsl(0, 100%, 50%)',
			white: 'hsl(0, 0%, 100%)',
			yellow: 'hsl(46, 100%, 64%)'
		},
		active: 'hsl(46, 100%, 64%)',
		border: 'hsl(0, 0%, 0%)',
		bounding: 'hsl(332, 55%, 46%)',
		boundingLight: 'hsla(332, 55%, 46%, 25%)',
		deprecated: 'hsl(45, 100%, 51%)',
		interaction: 'hsl(204, 66%, 56%)',
		interactionHover: 'hsl(187, 52%, 80%)',
		label: 'hsl(0, 0%, 100%)',
		new: 'hsl(181, 100%, 50%)',
		outdated: 'hsl(269, 69%, 69%)',
		seperator: 'hsl(0, 0%, 33%)',
		settings: 'hsl(0, 0%, 42%)'
	},
	fontFamily: {
		code: 'Consolas, "Liberation Mono", Menlo, monospace',
		notes: 'Lato, sans-serif'
	},
	name: 'style-guide'
};

var metadata = [{
	name: "ActionAnchor",
	path: "src/actions/anchors/ActionAnchor/package.json",
	variants: ["Download", "Upload"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "ActionButton",
	path: "src/actions/buttons/ActionButton/package.json",
	variants: ["Primary", "Secondary", "Add", "Download", "Edit", "Find", "Print", "Remove", "Search", "Upload"],
	"component-id": 1014,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "EmailLink",
	path: "src/actions/links/EmailLink/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "PhoneLink",
	path: "src/actions/links/PhoneLink/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "WebsiteLink",
	path: "src/actions/links/WebsiteLink/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "InputRadio",
	path: "src/actions/radios/InputRadio/package.json",
	variants: ["Default", "Grid", "List"],
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}]
}, {
	name: "InputRadioGroup",
	path: "src/actions/radios/InputRadioGroup/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}]
}, {
	name: "TallRadioCard",
	path: "src/actions/radios/TallRadioCard/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "WideRadioCard",
	path: "src/actions/radios/WideRadioCard/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "NewWindowAction",
	path: "src/advisor/actions/NewWindowAction/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "CustomerAlert",
	path: "src/advisor/alerts/CustomerAlert/package.json",
	variants: ["FraudLocked", "LockedServices"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ClickableContentFrame",
	path: "src/advisor/layout/ClickableContentFrame/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "DashboardGrid",
	path: "src/advisor/layout/DashboardGrid/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "WideModal",
	path: "src/advisor/layout/WideModal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "WindowFrame",
	path: "src/advisor/layout/WindowFrame/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ProductRadioCard",
	path: "src/advisor/radios/ProductRadioCard/package.json",
	variants: ["CreditCard", "DebitCard"],
	"component-id": 1037,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: true,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "AccountSelect",
	path: "src/advisor/selects/AccountSelect/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "SessionTimeoutTakeover",
	path: "src/advisor/takeovers/SessionTimeoutTakeover/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "Anchor",
	path: "src/atoms/buttons/Anchor/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}]
}, {
	name: "Button",
	path: "src/atoms/buttons/Button/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: [{
			name: "ActionButton",
			path: "Actions/Buttons"
		}, {
			name: "NavigationButton",
			path: "Navigation/Buttons"
		}]
	}]
}, {
	name: "ButtonTitle",
	path: "src/atoms/buttons/ButtonTitle/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Calendar",
	path: "src/atoms/forms/Calendar/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "Checkbox",
	path: "src/atoms/forms/Checkbox/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}]
}, {
	name: "CheckboxToggle",
	path: "src/atoms/forms/CheckboxToggle/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Datepicker",
	path: "src/atoms/forms/Datepicker/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Calendar",
			path: "Atoms/Forms"
		}
	}]
}, {
	name: "FieldDescription",
	path: "src/atoms/forms/FieldDescription/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Input",
	path: "src/atoms/forms/Input/Input/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "Prefix",
	path: "src/atoms/forms/Input/Prefix/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Suffix",
	path: "src/atoms/forms/Input/Suffix/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TextPrompt",
	path: "src/atoms/forms/Input/TextPrompt/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "InputClickable",
	path: "src/atoms/forms/InputClickable/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "InputRange",
	path: "src/atoms/forms/InputRange/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "LabelTitle",
	path: "src/atoms/forms/Label/LabelTitle/package.json",
	"component-id": "null",
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}]
}, {
	name: "Label",
	path: "src/atoms/forms/Label/package.json",
	"component-id": "null",
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}]
}, {
	name: "MediaCheckbox",
	path: "src/atoms/forms/MediaCheckbox/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "MediaRadio",
	path: "src/atoms/forms/MediaRadio/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "MultiSelect",
	path: "src/atoms/forms/MultiSelect/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Radio",
	path: "src/atoms/forms/Radio/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}]
}, {
	name: "RadioCard",
	path: "src/atoms/forms/RadioCard/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}]
}, {
	name: "Select",
	path: "src/atoms/forms/Select/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericSelect",
			path: "Data/Capture/Selects"
		}
	}]
}, {
	name: "Textarea",
	path: "src/atoms/forms/Textarea/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}]
}, {
	name: "TextAreaCharacterCount",
	path: "src/atoms/forms/TextAreaCharacterCount/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}]
}, {
	name: "TimeEstimationIcon",
	path: "src/atoms/forms/TimeEstimationIcon/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AnimatedIcon",
	path: "src/atoms/iconography/AnimatedIcon/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "DistinctiveGeneratedSymbol",
	path: "src/atoms/iconography/DistinctiveGeneratedSymbol/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Icon",
	path: "src/atoms/iconography/Icon/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ChevronLeftSmall",
			replacement: "ChevronLeftSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineLarge",
			replacement: "CrossOutlineLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidLarge",
			replacement: "CrossSolidLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidSmall",
			replacement: "CrossSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidLarge",
			replacement: "CycleLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidSmall",
			replacement: "CycleSmall",
			path: "Atoms/Iconography"
		}
	}]
}, {
	name: "Divider",
	path: "src/atoms/layout/Divider/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericDivider",
			path: "Layout/Content/Breaks"
		}
	}]
}, {
	name: "UploadPreviewContainer",
	path: "src/atoms/layout/UploadPreviewContainer/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AndroidStoreLogo",
	path: "src/atoms/logo/AndroidStoreLogo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AppleStoreLogo",
	path: "src/atoms/logo/AppleStoreLogo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "BankHeader",
	path: "src/atoms/logo/BankHeader/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}]
}, {
	name: "BLogo",
	path: "src/atoms/logo/BLogo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "BLogoCircular",
	path: "src/atoms/logo/BLogoCircular/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "CBLogo",
	path: "src/atoms/logo/CBLogo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "CBLogoCircular",
	path: "src/atoms/logo/CBLogoCircular/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Header",
	path: "src/atoms/logo/Header/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}]
}, {
	name: "SwitchGuaranteeLogo",
	path: "src/atoms/logo/SwitchGuaranteeLogo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "VMSecondaryRedLogo",
	path: "src/atoms/logo/VMSecondaryRedLogo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "YBLogo",
	path: "src/atoms/logo/YBLogo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "YBLogoCircular",
	path: "src/atoms/logo/YBLogoCircular/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Popover",
	path: "src/atoms/popovers/Popover/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "IdentityProcessingSignal",
	path: "src/atoms/signals/IdentityProcessingSignal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "UploadProcessingSignal",
	path: "src/atoms/signals/UploadProcessingSignal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "BadgeLabel",
	path: "src/atoms/text/BadgeLabel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "BulletedList",
	path: "src/atoms/text/BulletedList/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "BulletList",
			path: "Typography/Lists"
		}
	}]
}, {
	name: "Callout",
	path: "src/atoms/text/Callout/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}]
}, {
	name: "List",
	path: "src/atoms/text/List/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "NumberedList",
	path: "src/atoms/text/NumberedList/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "NumberList",
			path: "Typography/Lists"
		}
	}]
}, {
	name: "StatusBadge",
	path: "src/atoms/text/StatusBadge/package.json",
	variants: ["Active", "Archived", "Inactive"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TextBody",
	path: "src/atoms/text/TextBody/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "StandardBody",
			path: "Typography/Body"
		}
	}]
}, {
	name: "TextStyled",
	path: "src/atoms/text/TextStyled/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}]
}, {
	name: "TheSmallPrint",
	path: "src/atoms/text/TheSmallPrint/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "SmallestBody",
			path: "Typography/Body"
		}
	}]
}, {
	name: "Title",
	path: "src/atoms/text/Title/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Headings",
			path: "Typography"
		}
	}]
}, {
	name: "TransitionBlock",
	path: "src/atoms/transitions/TransitionBlock/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "EmailInput",
	path: "src/communication/email/text-inputs/EmailInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Mail",
	path: "src/communication/messaging/Mail/package.json",
	variants: ["List", "Item", "ToolBar", "Header", "Body", "Empty"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Webchat",
	path: "src/communication/support/Webchat/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "GenericCheckbox",
	path: "src/data/capture/checkboxes/GenericCheckbox/package.json",
	variants: ["InlineSet", "StackedSet"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "StandaloneCheckbox",
	path: "src/data/capture/checkboxes/StandaloneCheckbox/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "AccountNumberInput",
	path: "src/data/capture/inputs/AccountNumberInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "DateOfBirthInput",
	path: "src/data/capture/inputs/DateOfBirthInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "FileUploadInput",
	path: "src/data/capture/inputs/FileUploadInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: true
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": true,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "GenericAlphaNumericInput",
	path: "src/data/capture/inputs/GenericAlphaNumericInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "GenericTextInput",
	path: "src/data/capture/inputs/GenericTextInput/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericAlphaNumericInput",
			path: "Data/Capture/Inputs"
		}
	}]
}, {
	name: "LandlineNumberInput",
	path: "src/data/capture/inputs/LandlineNumberInput/package.json",
	"component-id": 1004,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": true,
			"firefox-desktop": true,
			"ie11-desktop": true
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "MoneyInput",
	path: "src/data/capture/inputs/MoneyInput/package.json",
	variants: ["PoundsOnly", "WithPence"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "MonthAndYearDateInput",
	path: "src/data/capture/inputs/MonthAndYearDateInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "SortcodeInput",
	path: "src/data/capture/inputs/SortcodeInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "UKOnlyMobileNumberInput",
	path: "src/data/capture/inputs/UKOnlyMobileNumberInput/package.json",
	"component-id": 1013,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": true,
			"firefox-desktop": true,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "UKOnlyPostcodeInput",
	path: "src/data/capture/inputs/UKOnlyPostcodeInput/package.json",
	"component-id": 1006,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "WorldwideMobileNumberInput",
	path: "src/data/capture/inputs/WorldwideMobileNumberInput/package.json",
	"component-id": 1011,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: true,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": true,
			"firefox-desktop": true,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "YearsAndMonthsCountInput",
	path: "src/data/capture/inputs/YearsAndMonthsCountInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "DayOfMonthPicker",
	path: "src/data/capture/pickers/DayOfMonthPicker/package.json",
	"component-id": 949,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "FileProgressTakeover",
	path: "src/data/capture/progress/FileProgressTakeover/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "GenericRadio",
	path: "src/data/capture/radios/GenericRadio/package.json",
	variants: ["InlineSet", "StackedSet"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "GenericSelect",
	path: "src/data/capture/selects/GenericSelect/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": true,
			"firefox-desktop": true,
			"ie11-desktop": true
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "GenericTextArea",
	path: "src/data/capture/text-areas/GenericTextArea/package.json",
	"component-id": 1001,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": true
	}
}, {
	name: "GenericPaginator",
	path: "src/data/filter-and-search/paginators/GenericPaginator/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "SearchTextInput",
	path: "src/data/filter-and-search/text-inputs/SearchTextInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "CompactDescriptionList",
	path: "src/data/lists/description-lists/CompactDescriptionList/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "GenericDescriptionList",
	path: "src/data/lists/description-lists/GenericDescriptionList/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "NoResultsTile",
	path: "src/data/results/tiles/NoResultsTile/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "DocumentLink",
	path: "src/documents/navigation/links/DocumentLink/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": true,
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons"
		}
	}]
}, {
	name: "DocumentLinkPlate",
	path: "src/documents/navigation/plates/DocumentLinkPlate/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": true,
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}]
}, {
	name: "PrintButton",
	path: "src/documents/printing/buttons/PrintButton/package.json",
	variants: ["Bottom", "Inline", "Top"],
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": true,
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons/ActionButton"
		}
	}]
}, {
	name: "DocumentStatusBandCard",
	path: "src/documents/statuses/cards/DocumentStatusBandCard/package.json",
	variants: ["Approved", "NotStarted", "Pending", "Rejected"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
}, {
	name: "FileInput",
	path: "src/documents/upload/FileInput/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": true,
	deprecations: [{
		replacements: {
			name: "FileUploadInput",
			path: "Data/Capture/Inputs"
		}
	}]
}, {
	name: "AccountCheckboxCard",
	path: "src/finance/accounts/cards/AccountCheckboxCard/package.json",
	variants: ["BankAccount", "CreditCard", "International"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountLegacyUpdateCard",
	path: "src/finance/accounts/cards/AccountLegacyUpdateCard/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "AccountLinkCard",
	path: "src/finance/accounts/cards/AccountLinkCard/package.json",
	variants: ["BankAccount", "CreditCard", "DebitCard", "International"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountPoolCard",
	path: "src/finance/accounts/cards/AccountPoolCard/package.json",
	"component-id": 1058,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "AccountSelectCard",
	path: "src/finance/accounts/cards/AccountSelectCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountAuthorisationPanel",
	path: "src/finance/accounts/panels/AccountAuthorisationPanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountBalancesSelectPanel",
	path: "src/finance/accounts/panels/AccountBalancesSelectPanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountLegacyPanel",
	path: "src/finance/accounts/panels/AccountLegacyPanel/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "AccountBalancesSelectPanel",
			path: "Finance/Accounts/Panels"
		}
	}]
}, {
	name: "AccountPoolTablePanel",
	path: "src/finance/accounts/panels/AccountPoolTablePanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountRadioCard",
	path: "src/finance/accounts/radios/AccountRadioCard/package.json",
	variants: ["BankAccount", "CreditCard", "Group"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountPaymentReviewTable",
	path: "src/finance/accounts/tables/AccountPaymentReviewTable/package.json",
	variants: ["Authorisation", "Default", "Failed"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountPaymentSubmittedTable",
	path: "src/finance/accounts/tables/AccountPaymentSubmittedTable/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountPaymentTable",
	path: "src/finance/accounts/tables/AccountPaymentTable/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountSummaryTile",
	path: "src/finance/accounts/tiles/AccountSummaryTile/package.json",
	variants: ["DebitCard"],
	"component-id": 1031,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "CurrencySelect",
	path: "src/finance/currency/selects/CurrencySelect/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FormInput",
	path: "src/forms/FormInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "BlockField",
	path: "src/global/layout/BlockField/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "BlockFieldColumn",
	path: "src/global/layout/BlockFieldColumn/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "CenterImageContainer",
	path: "src/global/layout/CenterImageContainer/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Column",
	path: "src/global/layout/Column/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}]
}, {
	name: "Container",
	path: "src/global/layout/Container/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContentContainer",
			path: "Layout/Sections"
		}
	}]
}, {
	name: "FlexColumn",
	path: "src/global/layout/FlexColumn/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}]
}, {
	name: "FlexRow",
	path: "src/global/layout/FlexRow/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}]
}, {
	name: "Frame",
	path: "src/global/layout/Frame/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}]
}, {
	name: "InternalSlot",
	path: "src/global/layout/InternalSlot/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "LeftAndRightAlignment",
	path: "src/global/layout/LeftAndRightAlignment/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}]
}, {
	name: "PageLayout",
	path: "src/global/layout/PageLayout/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}]
}, {
	name: "HeaderSection",
	path: "src/global/layout/Pages/HeaderSection/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}]
}, {
	name: "ServicingSection",
	path: "src/global/layout/Pages/ServicingSection/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "DataManagementShell",
			path: "Layout/Shells"
		}
	}]
}, {
	name: "WorkflowSection",
	path: "src/global/layout/Pages/WorkflowSection/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}]
}, {
	name: "ResponsiveLayoutPair",
	path: "src/global/layout/ResponsiveLayoutPair/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}]
}, {
	name: "Row",
	path: "src/global/layout/Row/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}]
}, {
	name: "ContentContainer",
	path: "src/layout/containers/ContentContainer/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}]
}, {
	name: "Main",
	path: "src/layout/containers/Main/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells/ApplicationFormShell"
		}
	}]
}, {
	name: "GenericAccordion",
	path: "src/layout/content/accordions/GenericAccordion/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "StatusBanner",
	path: "src/layout/content/banners/StatusBanner/package.json",
	variants: ["Success", "Information", "Warning"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "GenericDivider",
	path: "src/layout/content/breaks/GenericDivider/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "GenericModal",
	path: "src/layout/content/modals/GenericModal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": true,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": true,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "InformationModal",
	path: "src/layout/content/modals/InformationModal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": true,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": true,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "MultiButtonModal",
	path: "src/layout/content/modals/MultiButtonModal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": true,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": true,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "BrandedPanel",
	path: "src/layout/content/panels/BrandedPanel/package.json",
	"component-id": 978,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "ConditionalPanel",
	path: "src/layout/content/panels/ConditionalPanel/package.json",
	"component-id": 981,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "ContentRevealPanel",
	path: "src/layout/content/panels/ContentRevealPanel/package.json",
	"component-id": 1005,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "SubformRevealPanel",
			path: "Layout/Content/Panels"
		}
	}]
}, {
	name: "InformationRevealPanel",
	path: "src/layout/content/panels/InformationRevealPanel/package.json",
	"component-id": 596,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "ShellSidebarPanel",
	path: "src/layout/content/panels/ShellSidebarPanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "SimplePanel",
	path: "src/layout/content/panels/SimplePanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "StatusPanel",
	path: "src/layout/content/panels/StatusPanel/package.json",
	variants: ["Error", "Rejected", "Success", "Warning"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "SubformRevealPanel",
	path: "src/layout/content/panels/SubformRevealPanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "ToggleButtonPanel",
	path: "src/layout/content/panels/ToggleButtonPanel/package.json",
	"component-id": 823,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "ProcessingScreenTakeover",
	path: "src/layout/content/takeovers/ProcessingScreenTakeover/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "AttentionTile",
	path: "src/layout/content/tiles/AttentionTile/package.json",
	variants: ["Blocker", "Empty", "FraudAwareness", "Warning"],
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "GuidanceTile",
	path: "src/layout/content/tiles/GuidanceTile/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}]
}, {
	name: "OutcomeTile",
	path: "src/layout/content/tiles/OutcomeTile/package.json",
	variants: ["Success"],
	"component-id": 1049,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": true,
			"firefox-desktop": true,
			"ie11-desktop": true
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "RecapTile",
	path: "src/layout/content/tiles/RecapTile/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}]
}, {
	name: "StandoutTile",
	path: "src/layout/content/tiles/StandoutTile/package.json",
	variants: ["Important", "Guidance", "Remember", "Tip"],
	"component-id": 1048,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "ValidationMessageTile",
	path: "src/layout/content/tiles/ValidationMessageTile/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "GridViewToggle",
	path: "src/layout/content/views/GridViewToggle/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "GenericFieldWrapper",
	path: "src/layout/fieldWrappers/GenericFieldWrapper/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "MainFixedFooter",
	path: "src/layout/footers/MainFixedFooter/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "Grid",
	path: "src/layout/grids/Grid/package.json",
	variants: ["FullWidth", "TwoThirds"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "Inline",
	path: "src/layout/grids/Inline/package.json",
	variants: ["Centered", "Justified", "LeftAligned", "RightAligned"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: true
		},
		"motor-skills": {
			autocomplete: true,
			keyboard: true
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": true,
			"function-set": true
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "ContainedHeader",
	path: "src/layout/headers/ContainedHeader/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "FixedFooter",
	path: "src/layout/sections/footers/FixedFooter/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "MainFixedFooter",
			path: "Layout/Footers"
		}
	}]
}, {
	name: "ApplicationFormShell",
	path: "src/layout/shells/ApplicationFormShell/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "DataManagementShell",
	path: "src/layout/shells/DataManagementShell/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ShellInnerSpacer",
	path: "src/layout/shells/ShellInnerSpacer/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "VerticalReviewTable",
	path: "src/layout/tables/VerticalReviewTable/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "NonUKAddressFieldset",
	path: "src/location/addresses/fieldsets/NonUKAddressFieldset/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "UKAddressFieldset",
	path: "src/location/addresses/fieldsets/UKAddressFieldset/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "UKAddressCaptureModule",
	path: "src/location/addresses/modules/UKAddressCaptureModule/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "UKAddressCaptureModule2",
	path: "src/location/addresses/modules/UKAddressCaptureModule2/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "BaseSelect",
	path: "src/location/places/selects/BaseSelect/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "CountrySelect",
	path: "src/location/places/selects/CountrySelect/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "UKCitySelect",
	path: "src/location/places/selects/UKCitySelect/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccordionItem",
	path: "src/molecules/accordions/Accordion/AccordionItem/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}]
}, {
	name: "Accordion",
	path: "src/molecules/accordions/Accordion/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}]
}, {
	name: "AccordionTable",
	path: "src/molecules/accordions/AccordionTable/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}]
}, {
	name: "ContentReveal",
	path: "src/molecules/accordions/ContentReveal/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}]
}, {
	name: "ExpansionPanel",
	path: "src/molecules/accordions/ExpansionPanel/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}]
}, {
	name: "ExpansionTable",
	path: "src/molecules/accordions/ExpansionTable/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}]
}, {
	name: "ButtonGroup",
	path: "src/molecules/buttons/ButtonGroup/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: [{
			name: "NavigationButtonGroup",
			path: "Navigation/Buttons"
		}, {
			name: "Inline",
			path: "Layout/Grids"
		}]
	}]
}, {
	name: "SortingCardGroup",
	path: "src/molecules/card-groups/SortingCardGroup/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountCard",
	path: "src/molecules/cards/AccountCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "AccountSummaryLinkCard",
	path: "src/molecules/cards/AccountSummaryLinkCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "DateCard",
	path: "src/molecules/cards/DateCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PromoCard",
	path: "src/molecules/cards/PromoCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "StackingCard",
	path: "src/molecules/cards/StackingCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Autocomplete",
	path: "src/molecules/forms/Autocomplete/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ConfirmationCheckbox",
	path: "src/molecules/forms/ConfirmationCheckbox/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "StandaloneCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}]
}, {
	name: "DaySelector",
	path: "src/molecules/forms/DaySelector/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}]
}, {
	name: "FieldBody",
	path: "src/molecules/forms/Field/FieldBody/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}]
}, {
	name: "FieldHeader",
	path: "src/molecules/forms/Field/FieldHeader/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}]
}, {
	name: "FormField",
	path: "src/molecules/forms/Field/FormField/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Field",
	path: "src/molecules/forms/Field/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}]
}, {
	name: "PasswordReveal",
	path: "src/molecules/forms/PasswordReveal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "RadioCardGroup",
	path: "src/molecules/forms/RadioCardGroup/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}]
}, {
	name: "Search",
	path: "src/molecules/forms/Search/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "SearchForm",
	path: "src/molecules/forms/SearchForm/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "SegmentedControl",
	path: "src/molecules/forms/SegmentedControl/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "SegmentedControlItem",
	path: "src/molecules/forms/SegmentedControl/SegmentedControlItem/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "SegmentedSlider",
	path: "src/molecules/forms/SegmentedSlider/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TickMarks",
	path: "src/molecules/forms/SegmentedSlider/TickMarks/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ValidationMessage",
	path: "src/molecules/forms/ValidationMessage/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ValidationMessageTile",
			path: "Layout/Tiles"
		}
	}]
}, {
	name: "IconTextDynamic",
	path: "src/molecules/icon-text-dynamic/IconTextDynamic/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "IconText",
	path: "src/molecules/icon-text/IconText/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "IconTextDynamic",
			path: "Molecules/IconTextDynamic"
		}
	}]
}, {
	name: "BackAnchor",
	path: "src/molecules/navigation/BackAnchor/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}]
}, {
	name: "BackButton",
	path: "src/molecules/navigation/BackButton/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "UtilityNavButton",
			path: "Navigation/Site-navs"
		}
	}]
}, {
	name: "Utility",
	path: "src/molecules/navigation/Utility/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "UtilityNav",
			path: "Navigation/Site-Navs/UtilityNav"
		}
	}]
}, {
	name: "Alert",
	path: "src/molecules/nbas/Alert/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "Promo",
	path: "src/molecules/nbas/Promo/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ContrastingFormPanel",
	path: "src/molecules/panels/ContrastingFormPanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "DocumentAction",
	path: "src/molecules/panels/DocumentAction/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "IconifiedBulletPoint",
	path: "src/molecules/panels/IconifiedBulletPoint/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Panel",
	path: "src/molecules/panels/Panel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PanelBody",
	path: "src/molecules/panels/Panel/PanelBody/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PanelFooter",
	path: "src/molecules/panels/Panel/PanelFooter/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PanelHeader",
	path: "src/molecules/panels/Panel/PanelHeader/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PanelSector",
	path: "src/molecules/panels/Panel/PanelSector/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "SettingLink",
	path: "src/molecules/panels/SettingLink/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "SubordinatePanel",
	path: "src/molecules/panels/SubordinatePanel/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}]
}, {
	name: "TogglePanel",
	path: "src/molecules/panels/TogglePanel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PayeeCard",
	path: "src/molecules/payee-cards/PayeeCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PaymentReview",
	path: "src/molecules/payments/PaymentReview/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ProgressIndicator",
	path: "src/molecules/progress/ProgressIndicator/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}]
}, {
	name: "ProgressIndicatorItem",
	path: "src/molecules/progress/ProgressIndicator/ProgressIndicatorItem/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}]
}, {
	name: "ComparisonTable",
	path: "src/molecules/tables/ComparisonTable/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "DataTable",
	path: "src/molecules/tables/Table/DataTable/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "Table",
	path: "src/molecules/tables/Table/Table/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "TableBody",
	path: "src/molecules/tables/Table/TableBody/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TableBodyData",
	path: "src/molecules/tables/Table/TableBodyData/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TableHead",
	path: "src/molecules/tables/Table/TableHead/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TableHeadData",
	path: "src/molecules/tables/Table/TableHeadData/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TableRow",
	path: "src/molecules/tables/Table/TableRow/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "SectionHeading",
	path: "src/molecules/text/SectionHeading/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "SectionHeading",
			path: "Typography/Headings"
		}
	}]
}, {
	name: "ConfirmationTile",
	path: "src/molecules/tile/ConfirmationTile/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}]
}, {
	name: "ExclamationTile",
	path: "src/molecules/tile/ExclamationTile/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "HighlightTile",
	path: "src/molecules/tile/HighlightTile/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}]
}, {
	name: "IconTile",
	path: "src/molecules/tile/IconTile/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}]
}, {
	name: "NumberedTile",
	path: "src/molecules/tile/NumberedTile/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Tile",
	path: "src/molecules/tile/Tile/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TileSector",
	path: "src/molecules/tile/Tile/TileSector/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "TileSegment",
	path: "src/molecules/tile/Tile/TileSegment/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ToggleOption",
	path: "src/molecules/toggle/ToggleOption/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "NavigationButton",
	path: "src/navigation/buttons/NavigationButton/package.json",
	variants: ["Back", "Cancel", "Confirm", "Continue", "Next", "Primary", "Secondary", "Submit", "Tertiary"],
	"component-id": 812,
	"component-life-cycle": "active",
	"is-bespoke": false,
	deprecations: [{
		variants: ["Confirm", "Continue", "Next", "Submit"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Primary"
		}
	}, {
		variants: ["Back"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Secondary"
		}
	}, {
		variants: ["Cancel"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Tertiary"
		}
	}],
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "NavigationButtonGroup",
	path: "src/navigation/buttons/NavigationButtonGroup/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ProgressStepper",
	path: "src/navigation/indicators/ProgressStepper/package.json",
	"component-id": 893,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "MainNavLink",
	path: "src/navigation/nav-links/MainNavLink/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "Paginator",
	path: "src/navigation/pagination/Paginator/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "PaginatorNextButton",
	path: "src/navigation/pagination/Paginator/PaginatorNextButton/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "PaginatorPageButton",
	path: "src/navigation/pagination/Paginator/PaginatorPageButton/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "PaginatorPreviousButton",
	path: "src/navigation/pagination/Paginator/PaginatorPreviousButton/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "MainSiteNav",
	path: "src/navigation/site-navs/MainSiteNav/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "MobileMainSiteNav",
	path: "src/navigation/site-navs/MobileMainSiteNav/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "UtilityNav",
	path: "src/navigation/site-navs/UtilityNav/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "UtilityNavButton",
	path: "src/navigation/site-navs/UtilityNavButton/package.json",
	variants: ["Back", "Help"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: true
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "TabCard",
	path: "src/navigation/tab-cards/TabCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "TabCardBlock",
	path: "src/navigation/tab-cards/TabCardBlock/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "TabCardSmall",
	path: "src/navigation/tab-cards/TabCardSmall/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "TabGroup",
	path: "src/navigation/tab-group/TabGroup/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "TabButton",
	path: "src/navigation/tab-group/TabGroup/TabButton/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "TransferTakeover",
	path: "src/navigation/takeovers/TransferTakeover/package.json",
	variants: ["Incoming", "Outgoing"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": false,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: false,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "Card",
	path: "src/organisms/cards/Card/package.json",
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
}, {
	name: "DistinctiveLinkCard",
	path: "src/organisms/cards/DistinctiveLinkCard/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FilterAction",
	path: "src/organisms/filters/Filter/FilterActionGroup/FilterAction/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FilterActionGroup",
	path: "src/organisms/filters/Filter/FilterActionGroup/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FilterSector",
	path: "src/organisms/filters/Filter/FilterSector/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FilterSegment",
	path: "src/organisms/filters/Filter/FilterSegmentGroup/FilterSegment/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FilterSegmentGroup",
	path: "src/organisms/filters/Filter/FilterSegmentGroup/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FilterSubSegment",
	path: "src/organisms/filters/Filter/FilterSubSegmentGroup/FilterSubSegment/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "FilterSubSegmentGroup",
	path: "src/organisms/filters/Filter/FilterSubSegmentGroup/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Filter",
	path: "src/organisms/filters/Filter/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "GlobalHeader",
	path: "src/organisms/global/GlobalHeader/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}]
}, {
	name: "HeroHeader",
	path: "src/organisms/global/HeroHeader/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "CentredModal",
	path: "src/organisms/modals/CentredModal/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}]
}, {
	name: "ConfirmationModal",
	path: "src/organisms/modals/ConfirmationModal/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "GenericModal",
			path: "Layout/Content/Modals"
		}
	}]
}, {
	name: "Loader",
	path: "src/organisms/modals/Loader/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ModalBody",
	path: "src/organisms/modals/Modal/ModalBody/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ModalContainer",
	path: "src/organisms/modals/Modal/ModalContainer/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "ModalHeader",
	path: "src/organisms/modals/Modal/ModalHeader/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Modal",
	path: "src/organisms/modals/Modal/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}]
}, {
	name: "UnfinishedWorkModal",
	path: "src/organisms/modals/UnfinishedWorkModal/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "DisableTakeover",
	path: "src/organisms/takeovers/DisableTakeover/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "LoadingLocalTakeover",
	path: "src/organisms/takeovers/LoadingLocalTakeover/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "Timeline",
	path: "src/organisms/timelines/Timeline/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "LoanReasonSelector",
	path: "src/products/selection/LoanReasonSelector/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": false,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: false,
		yb: false,
		b: false
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": true,
			"firefox-desktop": true,
			"ie11-desktop": true
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ProductSelector",
	path: "src/products/selection/ProductSelector/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
}, {
	name: "EmailCreationInput",
	path: "src/security/authentication/inputs/EmailCreationInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "PasswordCreationInput",
	path: "src/security/authentication/inputs/PasswordCreationInput/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
}, {
	name: "CallButton",
	path: "src/telephony/Buttons/CallButton/package.json",
	variants: ["Answer", "Close", "Conference", "Dial", "End", "Hold", "Resume", "Retrieve", "Transfer"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
}, {
	name: "CallStatus",
	path: "src/telephony/Statuses/CallStatus/package.json",
	variants: ["AnswerCall", "ConferenceCall", "ConferenceMaskCall", "DialingCall", "HoldCall", "MakeCall", "OnCall"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
}, {
	name: "Footer",
	path: "src/typography/ancillary/Footer/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "LargeBody",
	path: "src/typography/body/LargeBody/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "SecondaryBody",
	path: "src/typography/body/SecondaryBody/package.json",
	"component-id": 1070,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": true,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": false
	}
}, {
	name: "SmallestBody",
	path: "src/typography/body/SmallestBody/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "StandardBody",
	path: "src/typography/body/StandardBody/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": true,
		"dev-format": true,
		"tech-format": true
	}
}, {
	name: "SubBody",
	path: "src/typography/body/SubBody/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "PageHeading",
	path: "src/typography/headings/PageHeading/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "SectionHeading",
	path: "src/typography/headings/SectionHeading/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "SubHeading",
	path: "src/typography/headings/SubHeading/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "SubsectionHeading",
	path: "src/typography/headings/SubsectionHeading/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "LargeHero",
	path: "src/typography/heros/LargeHero/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}]
}, {
	name: "StandardHero",
	path: "src/typography/heros/StandardHero/package.json",
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}]
}, {
	name: "IndicativeHighlight",
	path: "src/typography/highlights/IndicativeHighlight/package.json",
	variants: ["Value", "Description"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "StateIndicator",
	path: "src/typography/indicators/StateIndicator/package.json",
	variants: ["Active", "Editing", "Inactive", "Incomplete", "Locked", "Pending", "Spacer", "Unedited"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "FieldLabel",
	path: "src/typography/labels/FieldLabel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ProminentLabel",
	path: "src/typography/labels/ProminentLabel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "StandardLabel",
	path: "src/typography/labels/StandardLabel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "SubLabel",
	path: "src/typography/labels/SubLabel/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "BulletList",
	path: "src/typography/lists/BulletList/package.json",
	"component-id": 980,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "NegativeList",
	path: "src/typography/lists/NegativeList/package.json",
	"component-id": 1065,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "NumberList",
	path: "src/typography/lists/NumberList/package.json",
	"component-id": 1003,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": false,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "PositiveList",
	path: "src/typography/lists/PositiveList/package.json",
	"component-id": 1064,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "TickList",
	path: "src/typography/lists/TickList/package.json",
	"component-id": 1047,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "Identifier",
	path: "src/typography/modifiers/Identifier/package.json",
	variants: ["Breaking", "NonWrapping", "Truncated"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "AbbreviatedTag",
	path: "src/typography/tags/AbbreviatedTag/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "StatusTag",
	path: "src/typography/tags/StatusTag/package.json",
	variants: ["ErrorMajor", "ErrorMinor", "NotStarted", "Ongoing", "Paused", "Success", "WarningMajor", "WarningMinor"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ValueTag",
	path: "src/typography/tags/ValueTag/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "ProminentValue",
	path: "src/typography/values/ProminentValue/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"'style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": true,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "StandardValue",
	path: "src/typography/values/StandardValue/package.json",
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false,
	accessibility: {
		visual: {
			"colour-contrast": true,
			"font-size": true,
			zoom: false
		},
		auditory: {
			voiceover: false
		},
		"motor-skills": {
			autocomplete: false,
			keyboard: false
		}
	},
	tech: {
		framework: {
			"react-15": true,
			"react-16": false
		},
		"style-library": {
			"emotion-9": true,
			"emotion-10": false
		},
		api: {
			"prop-set": false,
			"function-set": false
		}
	},
	brand: {
		vm: true,
		cb: true,
		yb: true,
		b: true
	},
	browser: {
		desktop: {
			"chrome-desktop": true,
			"safari-desktop": false,
			"firefox-desktop": false,
			"ie11-desktop": false
		},
		ios: {
			"safari-ios": false,
			"chrome-ios": false
		},
		android: {
			"chrome-android": false,
			"samsung-android": false
		}
	},
	styleguide: {
		"default-example": false,
		"design-format": false,
		"dev-format": false,
		"tech-format": false
	}
}, {
	name: "UserStatusBandCard",
	path: "src/users/business-users/cards/UserStatusBandCard/package.json",
	variants: ["Active", "Group", "Pending"],
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": true
}, {
	name: "Banking",
	path: "src/utilities/Banking/package.json"
}, {
	name: "VMLoader",
	path: "src/utilities/components/VMLoader/package.json"
}, {
	name: "String",
	path: "src/utilities/String/package.json"
}, {
	name: "component-with-theme",
	path: "src/utilities/themes/component-with-theme/package.json"
}, {
	name: "WebUIThemeProvider",
	path: "src/utilities/themes/WebUIThemeProvider/package.json"
}];

var deprecationData = [{
	name: "InputRadio",
	path: "src/actions/radios/InputRadio/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.4.0",
	deprecationDate: "February 17 2020"
}, {
	name: "InputRadioGroup",
	path: "src/actions/radios/InputRadioGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.4.0",
	deprecationDate: "February 17 2020"
}, {
	name: "Anchor",
	path: "src/atoms/buttons/Anchor/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Button",
	path: "src/atoms/buttons/Button/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "ActionButton",
			path: "Actions/Buttons"
		}, {
			name: "NavigationButton",
			path: "Navigation/Buttons"
		}]
	}],
	deprecationVersion: "27.4.1",
	deprecationDate: "September 10 2020"
}, {
	name: "Checkbox",
	path: "src/atoms/forms/Checkbox/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Datepicker",
	path: "src/atoms/forms/Datepicker/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Calendar",
			path: "Atoms/Forms"
		}
	}],
	deprecationVersion: "7.3.0",
	deprecationDate: "August 30 2018"
}, {
	name: "LabelTitle",
	path: "src/atoms/forms/Label/LabelTitle/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "Label",
	path: "src/atoms/forms/Label/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "Radio",
	path: "src/atoms/forms/Radio/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.2.0",
	deprecationDate: "February 06 2020"
}, {
	name: "RadioCard",
	path: "src/atoms/forms/RadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Select",
	path: "src/atoms/forms/Select/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericSelect",
			path: "Data/Capture/Selects"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "Textarea",
	path: "src/atoms/forms/Textarea/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}],
	deprecationVersion: "19.0.0",
	deprecationDate: "May 03 2019"
}, {
	name: "TextAreaCharacterCount",
	path: "src/atoms/forms/TextAreaCharacterCount/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}],
	deprecationVersion: "20.0.0",
	deprecationDate: "May 15 2019"
}, {
	name: "Icon",
	path: "src/atoms/iconography/Icon/package.json",
	"component-life-cycle": "active",
	deprecations: [{
		replacements: {
			name: "ChevronLeftSmall",
			replacement: "ChevronLeftSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineLarge",
			replacement: "CrossOutlineLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidLarge",
			replacement: "CrossSolidLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidSmall",
			replacement: "CrossSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidLarge",
			replacement: "CycleLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidSmall",
			replacement: "CycleSmall",
			path: "Atoms/Iconography"
		}
	}]
}, {
	name: "Divider",
	path: "src/atoms/layout/Divider/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericDivider",
			path: "Layout/Content/Breaks"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "BankHeader",
	path: "src/atoms/logo/BankHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "Header",
	path: "src/atoms/logo/Header/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "BulletedList",
	path: "src/atoms/text/BulletedList/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "BulletList",
			path: "Typography/Lists"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "Callout",
	path: "src/atoms/text/Callout/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "NumberedList",
	path: "src/atoms/text/NumberedList/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "NumberList",
			path: "Typography/Lists"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "TextBody",
	path: "src/atoms/text/TextBody/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandardBody",
			path: "Typography/Body"
		}
	}],
	deprecationVersion: "22.3.0",
	deprecationDate: "August 05 2019"
}, {
	name: "TextStyled",
	path: "src/atoms/text/TextStyled/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "22.3.0",
	deprecationDate: "August 05 2019"
}, {
	name: "TheSmallPrint",
	path: "src/atoms/text/TheSmallPrint/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SmallestBody",
			path: "Typography/Body"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Title",
	path: "src/atoms/text/Title/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Headings",
			path: "Typography"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "GenericTextInput",
	path: "src/data/capture/inputs/GenericTextInput/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAlphaNumericInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "25.1.0",
	deprecationDate: "March 23 2020"
}, {
	name: "DocumentLink",
	path: "src/documents/navigation/links/DocumentLink/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "DocumentLinkPlate",
	path: "src/documents/navigation/plates/DocumentLinkPlate/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "PrintButton",
	path: "src/documents/printing/buttons/PrintButton/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons/ActionButton"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FileInput",
	path: "src/documents/upload/FileInput/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "FileUploadInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "AccountLegacyPanel",
	path: "src/finance/accounts/panels/AccountLegacyPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "AccountBalancesSelectPanel",
			path: "Finance/Accounts/Panels"
		}
	}],
	deprecationVersion: "22.1.0",
	deprecationDate: "July 17 2019"
}, {
	name: "Column",
	path: "src/global/layout/Column/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "Container",
	path: "src/global/layout/Container/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentContainer",
			path: "Layout/Sections"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "FlexColumn",
	path: "src/global/layout/FlexColumn/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "FlexRow",
	path: "src/global/layout/FlexRow/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "Frame",
	path: "src/global/layout/Frame/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "LeftAndRightAlignment",
	path: "src/global/layout/LeftAndRightAlignment/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "PageLayout",
	path: "src/global/layout/PageLayout/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "HeaderSection",
	path: "src/global/layout/Pages/HeaderSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ServicingSection",
	path: "src/global/layout/Pages/ServicingSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "DataManagementShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "WorkflowSection",
	path: "src/global/layout/Pages/WorkflowSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ResponsiveLayoutPair",
	path: "src/global/layout/ResponsiveLayoutPair/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.2.2",
	deprecationDate: "July 31 2020"
}, {
	name: "Row",
	path: "src/global/layout/Row/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "ContentContainer",
	path: "src/layout/containers/ContentContainer/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Main",
	path: "src/layout/containers/Main/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells/ApplicationFormShell"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ContentRevealPanel",
	path: "src/layout/content/panels/ContentRevealPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SubformRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.7.0",
	deprecationDate: "December 16 2020"
}, {
	name: "GuidanceTile",
	path: "src/layout/content/tiles/GuidanceTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "RecapTile",
	path: "src/layout/content/tiles/RecapTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FixedFooter",
	path: "src/layout/sections/footers/FixedFooter/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "MainFixedFooter",
			path: "Layout/Footers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "AccordionItem",
	path: "src/molecules/accordions/Accordion/AccordionItem/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Accordion",
	path: "src/molecules/accordions/Accordion/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "AccordionTable",
	path: "src/molecules/accordions/AccordionTable/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ContentReveal",
	path: "src/molecules/accordions/ContentReveal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "24.1.0",
	deprecationDate: "March 05 2020"
}, {
	name: "ExpansionPanel",
	path: "src/molecules/accordions/ExpansionPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "ExpansionTable",
	path: "src/molecules/accordions/ExpansionTable/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "ButtonGroup",
	path: "src/molecules/buttons/ButtonGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "NavigationButtonGroup",
			path: "Navigation/Buttons"
		}, {
			name: "Inline",
			path: "Layout/Grids"
		}]
	}],
	deprecationVersion: "27.4.1",
	deprecationDate: "September 10 2020"
}, {
	name: "ConfirmationCheckbox",
	path: "src/molecules/forms/ConfirmationCheckbox/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandaloneCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "DaySelector",
	path: "src/molecules/forms/DaySelector/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FieldBody",
	path: "src/molecules/forms/Field/FieldBody/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "FieldHeader",
	path: "src/molecules/forms/Field/FieldHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "Field",
	path: "src/molecules/forms/Field/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/FieldWrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "RadioCardGroup",
	path: "src/molecules/forms/RadioCardGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ValidationMessage",
	path: "src/molecules/forms/ValidationMessage/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ValidationMessageTile",
			path: "Layout/Tiles"
		}
	}],
	deprecationVersion: "22.22.0",
	deprecationDate: "January 20 2020"
}, {
	name: "IconText",
	path: "src/molecules/icon-text/IconText/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "IconTextDynamic",
			path: "Molecules/IconTextDynamic"
		}
	}],
	deprecationVersion: "6.4.0",
	deprecationDate: "August 03 2018"
}, {
	name: "BackAnchor",
	path: "src/molecules/navigation/BackAnchor/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "BackButton",
	path: "src/molecules/navigation/BackButton/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "UtilityNavButton",
			path: "Navigation/Site-navs"
		}
	}],
	deprecationVersion: "25.5.0",
	deprecationDate: "May 13 2020"
}, {
	name: "Utility",
	path: "src/molecules/navigation/Utility/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "UtilityNav",
			path: "Navigation/Site-Navs/UtilityNav"
		}
	}],
	deprecationVersion: "22.12.0",
	deprecationDate: "September 27 2019"
}, {
	name: "SubordinatePanel",
	path: "src/molecules/panels/SubordinatePanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ProgressIndicator",
	path: "src/molecules/progress/ProgressIndicator/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}],
	deprecationVersion: "26.0.0",
	deprecationDate: "May 22 2020"
}, {
	name: "ProgressIndicatorItem",
	path: "src/molecules/progress/ProgressIndicator/ProgressIndicatorItem/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}],
	deprecationVersion: "26.0.0",
	deprecationDate: "May 22 2020"
}, {
	name: "SectionHeading",
	path: "src/molecules/text/SectionHeading/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SectionHeading",
			path: "Typography/Headings"
		}
	}],
	deprecationVersion: "23.2.0",
	deprecationDate: "February 06 2020"
}, {
	name: "ConfirmationTile",
	path: "src/molecules/tile/ConfirmationTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "HighlightTile",
	path: "src/molecules/tile/HighlightTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "IconTile",
	path: "src/molecules/tile/IconTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "NavigationButton",
	path: "src/navigation/buttons/NavigationButton/package.json",
	"component-life-cycle": "active",
	deprecations: [{
		variants: ["Confirm", "Continue", "Next", "Submit"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Primary"
		}
	}, {
		variants: ["Back"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Secondary"
		}
	}, {
		variants: ["Cancel"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Tertiary"
		}
	}],
	deprecationVersion: "NO RELEASE VERSION FOUND",
	deprecationDate: "NO RELEASE DATE FOUND"
}, {
	name: "GlobalHeader",
	path: "src/organisms/global/GlobalHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "CentredModal",
	path: "src/organisms/modals/CentredModal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}],
	deprecationVersion: "22.0.0",
	deprecationDate: "July 04 2019"
}, {
	name: "ConfirmationModal",
	path: "src/organisms/modals/ConfirmationModal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericModal",
			path: "Layout/Content/Modals"
		}
	}],
	deprecationVersion: "27.8.0",
	deprecationDate: "January 29 2021"
}, {
	name: "Modal",
	path: "src/organisms/modals/Modal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}],
	deprecationVersion: "22.0.0",
	deprecationDate: "July 04 2019"
}, {
	name: "LargeHero",
	path: "src/typography/heros/LargeHero/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "StandardHero",
	path: "src/typography/heros/StandardHero/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}];

var checkComponentHasDeprecations = function checkComponentHasDeprecations(componentName) {
	return !!deprecationData.find(function (obj) {
		return obj.name === componentName;
	});
};

var getDeprecations = function getDeprecations(componentName) {
	return deprecationData.find(function (obj) {
		return obj.name === componentName;
	}).deprecations;
};

var getVariantDeprecations = function getVariantDeprecations(componentName) {
	var deprecatedVariants = [];
	if (!checkComponentHasDeprecations(componentName)) {
		return deprecatedVariants;
	}

	getDeprecations(componentName).map(function (deprecationObj) {
		return deprecationObj.variants.map(function (variant) {
			return deprecatedVariants.push(variant);
		});
	});
	return deprecatedVariants;
};

var checkIsComponentDeprecated = function checkIsComponentDeprecated(componentName, variant) {
	return getComponentLifeCycleStatus(componentName) === 'deprecated' || (variant ? getVariantDeprecations(componentName).includes(variant) : false);
};

var getComponentMetadata = function getComponentMetadata(componentName) {
	return metadata.find(function (_ref3) {
		var name = _ref3.name;
		return name === componentName;
	});
};

var getComponentLifeCycleStatus = function getComponentLifeCycleStatus(componentName) {
	var metadata = getComponentMetadata(componentName);
	return !metadata ? null : metadata['component-life-cycle'];
};

var isComponentBespoke = function isComponentBespoke(componentName) {
	return getComponentMetadata(componentName)['is-bespoke'];
};

var getComponentProminentStatus = function getComponentProminentStatus(componentName, variant) {
	if (checkIsComponentDeprecated(componentName, variant)) {
		return 'deprecated';
	}

	return isComponentBespoke(componentName) ? 'bespoke' : getComponentLifeCycleStatus(componentName);
};

var _templateObject$1 = taggedTemplateLiteral(['\n\t', ' ', ';\n\t', ';\n'], ['\n\t', ' ', ';\n\t', ';\n']);

var getFontProperties = function getFontProperties(props) {
	var fontProperties = 'font-size: 16px; line-height: 1.5;';
	// TODOxCYBG To be revisited with responsive VM typography.
	// if (props.theme.name !== 'vm') {
	fontProperties = props.theme.isCompact ? fontSize('bute') : fontSize('jura');
	// }
	return fontProperties;
};

var StyledInternalStandardBody = styled('div')(_templateObject$1, getFontProperties, function (props) {
	return !props.isFlush && 'margin-bottom: ' + spacing.DOUBLE;
}, function (props) {
	return !props.isFlush && 'margin-right: ' + spacing.DOUBLE;
});

var InternalStandardBody = function InternalStandardBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children;
	return React.createElement(
		StyledInternalStandardBody,
		{ isFlush: isFlush },
		children
	);
};

InternalStandardBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool
};

InternalStandardBody.defaultProps = {
	isFlush: false
};

var _templateObject$2 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n'], ['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n'], ['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n']);

var StyledUL = styled('ul')(_templateObject$2, function (props) {
	return props.theme.colours.bodyText;
}, spacing.DOUBLE, spacing.TRIPLE, spacing.DOUBLE);

var BORDER_RADIUS_DIVIDER = 4;
var BORDER_RADIUS_REMAINDER = 3;

var StyledListItem = styled('li')(_templateObject2$1, spacing.SINGLE, colours.neutral.black, function (props) {
	return props.level % 2 > 0 ? colours.neutral.black : 'transparent';
}, function (props) {
	return props.level % BORDER_RADIUS_DIVIDER === BORDER_RADIUS_REMAINDER || props.level % BORDER_RADIUS_DIVIDER === 0 ? '0' : '100%';
});

var processItems = function processItems(items, level) {
	return items.map(function (item, index) {
		return Array.isArray(item) ? React.createElement(
			StyledUL,
			{ key: level + '.' + [index] },
			processItems(item, level + 1)
		) : React.createElement(
			StyledListItem,
			{ key: level + '.' + [index], level: level },
			React.createElement(
				InternalStandardBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					item
				)
			)
		);
	});
};

var InternalBulletList = function InternalBulletList(_ref) {
	var items = _ref.items;
	return items !== ( undefined) && React.createElement(
		StyledUL,
		null,
		processItems(items, 1)
	);
};

InternalBulletList.propTypes = {
	/** An array of strings for each item. Can include other arrays for sub items. */
	items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])).isRequired
};

var _extends$g = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$f(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$7 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$f(_ref, ["styles"]);

  return React.createElement("svg", _extends$g({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-triangleright-large"), React.createElement("path", { d: "M16 8L0 16V0" }));
});

var _extends$h = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$g(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$7 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$g(_ref, ["styles"]);

  return React.createElement("svg", _extends$h({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13.75 1.849l68.847 45.515-67.217 47.89" }));
});

var getTriangleRightLarge = getThemeIcon(VMIcon$7, GenericIcon$7);

var _templateObject$3 = taggedTemplateLiteral(['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n'], ['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n']),
    _templateObject2$2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var StyledBodyContent = styled('div')(_templateObject$3, spacing.DOUBLE, function (props) {
	return props.isOpen ? '\n\t\t\t\tanimation: ' + animations.fadeIn + ' 0.7s linear;\n\t\t\t  ' : '\n\t\t\t\tanimation: ' + animations.fadeOut + ' 0.5s linear;\n\t\t\t  ';
}, function (props) {
	return props.isOpen && '\n\t\tmax-height: 4000px;\n\t\toverflow: visible;\n\t\tpadding-bottom: ' + spacing.SINGLE + ';\n\t\tpadding-left: ' + spacing.DOUBLE + ';\n\n\t';
}, function (props) {
	return props.panelColour;
});

var StyledButton = styled('button')(_templateObject2$2, function (props) {
	return props.panelColour;
}, useFontSize.of.jura, function (props) {
	return props.panelColour;
}, function (props) {
	return props.isOpen && !props.hasIconOverride && '\n\t\tmargin-bottom: ' + spacing.DOUBLE + ';\n\n\t\t> svg {\n\t\t\ttransform: rotate(90deg) !important;\n\t\t}\n\t';
}, function (props) {
	return props.isHeadingString ? '6' : '8';
}, function (props) {
	return props.isHeadingString && 'padding: 0 2px;';
}, breakpoints.md1, function (props) {
	return props.theme.borderRadius;
}, colours.component.focusOutline);

var StyledWrapper = styled('div')(_templateObject3$1, function (props) {
	return props.hasAdditionalMarginBottom && 'margin-bottom: ' + spacing.TRIPLE;
});

var InternalContentRevealPanel = function InternalContentRevealPanel(_ref) {
	var children = _ref.children,
	    hasAdditionalMarginBottom = _ref.hasAdditionalMarginBottom,
	    titleText = _ref.titleText,
	    icon = _ref.icon,
	    isOpen = _ref.isOpen,
	    onClick = _ref.onClick,
	    panelColour = _ref.panelColour,
	    theme = _ref.theme;

	var isHeadingString = typeof titleText === 'string';
	var ariaLabel = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') : 'content-reveal-panel';
	var TriangleRightLargeIcon = getTriangleRightLarge(theme.name);
	var hasIconOverride = icon !== undefined;
	return React.createElement(
		StyledWrapper,
		{ hasAdditionalMarginBottom: hasAdditionalMarginBottom },
		React.createElement(
			StyledButton,
			{
				'aria-labelledby': ariaLabel,
				isOpen: isOpen,
				hasIconOverride: hasIconOverride,
				onClick: onClick,
				panelColour: panelColour,
				type: 'button'
			},
			icon ? icon : React.createElement(TriangleRightLargeIcon, null),
			React.createElement(
				'div',
				{ className: 'buttonLabel' },
				isHeadingString ? React.createElement(
					InternalStandardBody,
					{ isFlush: true },
					React.createElement(
						'span',
						{ id: ariaLabel },
						titleText
					)
				) : titleText
			)
		),
		React.createElement(
			StyledBodyContent,
			{ isOpen: isOpen, panelColour: panelColour },
			children
		)
	);
};

InternalContentRevealPanel.propTypes = {
	/** Content of the panel. */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	/** Adds additional margin bottom. */
	hasAdditionalMarginBottom: PropTypes.bool,
	/** Set to true to open panel. */
	isOpen: PropTypes.bool,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Sets panel colour. */
	panelColour: PropTypes.string.isRequired,
	/** Title text. */
	titleText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

InternalContentRevealPanel.defaultProps = {
	hasAdditionalMarginBottom: false,
	isOpen: false
};

var WrappedInternalContentRevealPanel = withTheme(InternalContentRevealPanel);

var _templateObject$4 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject2$3 = taggedTemplateLiteral(['\n\t', ';\n\tdisplay: inline-block;\n'], ['\n\t', ';\n\tdisplay: inline-block;\n']),
    _templateObject3$2 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n'], ['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n'], ['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n']),
    _templateObject5$1 = taggedTemplateLiteral(['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n'], ['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n']),
    _templateObject6$1 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n'], ['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n']);

var BasicBlockWrapper = styled('div')(_templateObject$4, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
});

var BasicInlineWrapper = styled('span')(_templateObject2$3, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
});

var BasicDetails = styled('span')(_templateObject3$2, function (props) {
	return props.content;
}, styleGuideTheme.borderRadius, colours.neutral.black, spacing.QUARTER);

var InfoContainer = styled('div')(_templateObject4$1, function (props) {
	return props.content;
}, spacing.SINGLE, spacing.SINGLE, spacing.DOUBLE, spacing.DOUBLE, spacing.SINGLE, colours.neutral.black);

var InfoContentWrapper = styled('div')(_templateObject5$1, spacing.SINGLE, colours.neutral.black, spacing.SINGLE);

var InnerComponentWrapper = styled('div')(_templateObject$4, function (props) {
	return props.isContainer && '\n\t\tbackground-color: hsla(0, 100%, 100%, 60%);\n\t\tpadding: ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE + ';\n\t';
});

var XRayComponentWrapper = styled('div')(_templateObject6$1, function (props) {
	return props.background;
}, function (props) {
	return props.isContainer ? '0' : spacing.SINGLE + ' ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE;
});

var revealContent = {
	active: React.createElement(
		'span',
		null,
		'Details on this component can be found in the Web UI Components the style guide.'
	),
	bespoke: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component was built for a certainuse case and should not be used outside of that.'
		),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		)
	),
	deprecated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Deprecated components are no longer tested via:'
		),
		React.createElement(InternalBulletList, {
			items: ['Visual regression & brand testing.', 'Integration testing.', 'Manual input testing.', 'Accessibility testing.']
		}),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		),
		React.createElement(
			'p',
			null,
			React.createElement(
				'b',
				null,
				React.createElement(
					'u',
					null,
					'Upgrade as soon as possible.'
				)
			)
		)
	),
	draft: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Do not log defects for:'
		),
		React.createElement(InternalBulletList, {
			items: ['Appearance or styles.', 'Keyboard or mouse behaviours.', 'Missing input validations.'],
			isFlush: true
		}),
		React.createElement(
			'p',
			null,
			'Upgrade before using in production.'
		)
	),
	outdated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component is outdated. Therefore, should not be used in newer project work.'
		),
		React.createElement(
			'p',
			null,
			'It may have issues with:'
		),
		React.createElement(InternalBulletList, { items: ['Accessibility.', 'Consistency.', 'Optimisation.'], isFlush: true }),
		React.createElement(
			'p',
			null,
			'Before adding to a new codebase, contact the UI team about seeking a replacement.'
		)
	)
};

var getComponentName = function getComponentName(packageJson) {
	return packageJson.main.split('.')[0];
};

var InternalComponentFrame = function (_Component) {
	inherits(InternalComponentFrame, _Component);

	function InternalComponentFrame(props) {
		classCallCheck(this, InternalComponentFrame);

		var _this = possibleConstructorReturn(this, (InternalComponentFrame.__proto__ || Object.getPrototypeOf(InternalComponentFrame)).call(this, props));

		_this.state = {
			isOpen: false
		};
		return _this;
	}

	createClass(InternalComponentFrame, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    children = _props.children,
			    hasCustomMargins = _props.hasCustomMargins,
			    layout = _props.layout,
			    isFlush = _props.isFlush,
			    packageJson = _props.packageJson,
			    variant = _props.variant,
			    xraySuppressed = _props.xraySuppressed;
			var isOpen = this.state.isOpen;
			var _window = window,
			    XrayHelper = _window.XrayHelper;


			var componentName = getComponentName(packageJson);
			var status = getComponentProminentStatus(componentName, variant);
			var formattedStatus = stringHelpers_2(status);
			var variantSuffix = variant ? '.' + variant : '';

			var isContainer = layout === 'container';
			var isInline = layout === 'inline';
			var isTypography = layout === 'typography';
			var isCompactLayout = isInline || isTypography;
			var _colours$component$fr = colours.component.frame[status],
			    background = _colours$component$fr.background,
			    content = _colours$component$fr.content;


			if (xraySuppressed || XrayHelper && XrayHelper.checkIsXrayMode() === false) {
				return isInline ? React.createElement(
					BasicInlineWrapper,
					{ removeFrameMargins: hasCustomMargins || isFlush },
					children
				) : React.createElement(
					BasicBlockWrapper,
					{ removeFrameMargins: hasCustomMargins || isFlush },
					children
				);
			}

			return isCompactLayout ? React.createElement(
				'div',
				null,
				children,
				React.createElement(
					BasicDetails,
					{ content: content },
					React.createElement(
						'b',
						null,
						formattedStatus,
						' component:'
					),
					' ',
					componentName,
					variantSuffix
				)
			) : React.createElement(
				'div',
				null,
				React.createElement(
					XRayComponentWrapper,
					{ background: background, isContainer: isContainer },
					React.createElement(
						InnerComponentWrapper,
						{ isContainer: isContainer },
						children
					)
				),
				React.createElement(
					InfoContainer,
					{ content: content },
					React.createElement(
						WrappedInternalContentRevealPanel,
						{
							panelColour: 'black',
							titleText: formattedStatus + ' component: ' + getComponentName(packageJson) + variantSuffix,
							isOpen: isOpen,
							onClick: function onClick() {
								return _this2.setState(function (prevState) {
									return { isOpen: !prevState.isOpen };
								});
							}
						},
						React.createElement(
							InfoContentWrapper,
							null,
							revealContent[status]
						)
					)
				)
			);
		}
	}]);
	return InternalComponentFrame;
}(Component);

InternalComponentFrame.propTypes = {
	children: PropTypes.node.isRequired,
	hasCustomMargins: PropTypes.bool,
	isFlush: PropTypes.bool,
	layout: PropTypes.oneOf(['block', 'inline', 'container', 'typography']),
	packageJson: PropTypes.object.isRequired,
	variant: PropTypes.string,
	xraySuppressed: PropTypes.bool
};

InternalComponentFrame.defaultProps = {
	hasCustomMargins: false,
	isFlush: false,
	layout: 'block',
	xraySuppressed: false
};

var main = "StandardLabel.js";
var packageJson = {
	main: main,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$5 = taggedTemplateLiteral(['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n'], ['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n']);

var getFontProperties$1 = function getFontProperties(props) {
	var fontProperties = 'font-size: 16px; line-height: 1.5;';
	// TODOxCYBG To be revisited with responsive VM typography.
	// if (props.theme.name !== 'vm') {
	fontProperties = props.theme.isCompact ? fontSize('uist') : fontSize('jura');
	// }
	return fontProperties;
};

var StyledStandardLabel = styled('div')(_templateObject$5, getFontProperties$1, function (props) {
	return props.theme.fonts.standardLabel;
}, function (props) {
	return !props.isFlush && 'margin-bottom: ' + spacing.DOUBLE;
}, function (props) {
	return !props.isFlush && 'margin-right: ' + spacing.DOUBLE;
});

var StandardLabel = function StandardLabel(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledStandardLabel,
			{ isFlush: isFlush },
			children
		)
	);
};

StandardLabel.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool
};

StandardLabel.defaultProps = {
	isFlush: false
};

StandardLabel.defaultExample = function () {
	return React.createElement(
		StandardLabel,
		null,
		React.createElement(
			'span',
			null,
			'StandardLabel'
		)
	);
};

var main$1 = "ActionButton.js";
var variants = ["Primary", "Secondary", "Add", "Download", "Edit", "Find", "Print", "Remove", "Search", "Upload"];
var packageJson$1 = {
	main: main$1,
	variants: variants,
	"component-id": 1014,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$6 = taggedTemplateLiteral(['\n\talign-items: center;\n\tappearance: none;\n\tbackground-color: ', ';\n\tborder: 2px solid ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tdisplay: inline-flex;\n\theight: 48px;\n\tjustify-content: space-between;\n\tmax-width: 100%;\n\tpadding: 0 ', ';\n\ttransition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, color 0.2s ease-in-out;\n\n\t', '\n\n\tsvg {\n\t\t', '\n\t\tfill: ', ';\n\t\theight: 20px;\n\t\tmargin-right: ', ';\n\t\ttransition: fill 0.2s ease-in-out;\n\t\twidth: 20px;\n\t}\n'], ['\n\talign-items: center;\n\tappearance: none;\n\tbackground-color: ', ';\n\tborder: 2px solid ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tdisplay: inline-flex;\n\theight: 48px;\n\tjustify-content: space-between;\n\tmax-width: 100%;\n\tpadding: 0 ', ';\n\ttransition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, color 0.2s ease-in-out;\n\n\t', '\n\n\tsvg {\n\t\t', '\n\t\tfill: ', ';\n\t\theight: 20px;\n\t\tmargin-right: ', ';\n\t\ttransition: fill 0.2s ease-in-out;\n\t\twidth: 20px;\n\t}\n']),
    _templateObject2$4 = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n']),
    _templateObject3$3 = taggedTemplateLiteral(['\n\twidth: 100%;\n'], ['\n\twidth: 100%;\n']);

function getBackgroundColour(props) {
	var backgroundColour = props.theme.colours.disabledActionButton;
	if (!props.disabled) {
		backgroundColour = props.isSecondary ? colours.backgrounds.component : props.theme.colours.interaction;
	}
	return backgroundColour;
}

function getBodyColour(props) {
	var bodyColour = colours.neutral.white;
	if (!props.disabled && props.isSecondary) {
		bodyColour = props.theme.colours.interaction;
	}
	return bodyColour;
}

function getFillColour(props) {
	var fillColour = colours.neutral.white;
	if (!props.disabled && props.isSecondary) {
		fillColour = props.theme.colours.interaction;
	}
	return fillColour;
}

var StyledButton$1 = styled('button')(_templateObject$6, function (props) {
	return getBackgroundColour(props);
}, function (props) {
	return props.disabled ? props.theme.colours.disabledActionButton : props.theme.colours.interaction;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return getBodyColour(props);
}, spacing.TRIPLE, function (props) {
	return !props.disabled && ':hover {\n\t\tbackground-color: ' + (props.isSecondary ? props.theme.colours.interaction : props.theme.colours.interactionAccent) + ';\n\t\tborder-color: ' + (props.isSecondary ? props.theme.colours.interaction : props.theme.colours.interactionAccent) + ';\n\t\tcolor: ' + colours.neutral.white + ';\n\t\tsvg {\n\t\t\tfill:  ' + colours.neutral.white + ';\n\t\t}\n\t}';
}, function (props) {
	return props.isLoading && 'animation: spin 0.75s linear infinite;';
}, function (props) {
	return getFillColour(props);
}, spacing.DOUBLE);

var StyledIconWrapper = styled('div')(_templateObject2$4);

var StyledLabelWrapper = styled('div')(_templateObject3$3);

var BaseActionButton = function (_Component) {
	inherits(BaseActionButton, _Component);

	function BaseActionButton(props) {
		classCallCheck(this, BaseActionButton);

		var _this = possibleConstructorReturn(this, (BaseActionButton.__proto__ || Object.getPrototypeOf(BaseActionButton)).call(this, props));

		_this.refButton = null;
		return _this;
	}

	createClass(BaseActionButton, [{
		key: 'focus',
		value: function focus() {
			if (this.refButton) {
				this.refButton.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    icon = _props.icon,
			    innerRef = _props.innerRef,
			    isLoading = _props.isLoading,
			    isSecondary = _props.isSecondary,
			    labelText = _props.labelText,
			    loadingText = _props.loadingText,
			    onClick = _props.onClick;


			if (innerRef) {
				innerRef(this);
			}

			return React.createElement(
				StyledButton$1,
				{
					innerRef: function innerRef(component) {
						_this2.refButton = component;
					},
					disabled: isLoading,
					isLoading: isLoading,
					isSecondary: isSecondary,
					onClick: onClick
				},
				React.createElement(
					StyledIconWrapper,
					null,
					isLoading && React.createElement(LoadingOutlineSmallIcon, null),
					icon && !isLoading && icon
				),
				React.createElement(
					StyledLabelWrapper,
					null,
					React.createElement(
						StandardLabel,
						{ isFlush: true },
						isLoading ? loadingText : labelText
					)
				)
			);
		}
	}]);
	return BaseActionButton;
}(Component);

var baseProps = {
	/** Used to access the internal button inside the theme wrapper. */
	innerRef: PropTypes.func,
	/** Shows the loading spinner and loading text when true. */
	isLoading: PropTypes.bool,
	/** Sets the text when the isLoading prop is set to true. */
	loadingText: PropTypes.string,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired
};

BaseActionButton.propTypes = _extends$1({}, baseProps, {
	isSecondary: PropTypes.bool,
	icon: PropTypes.node,
	/** Button text. */
	labelText: PropTypes.string
});

BaseActionButton.defaultProps = {
	isLoading: false,
	loadingText: 'Loading',
	isSecondary: false
};

var Primary = function Primary(_ref) {
	var innerRef = _ref.innerRef,
	    isLoading = _ref.isLoading,
	    labelText = _ref.labelText,
	    loadingText = _ref.loadingText,
	    onClick = _ref.onClick;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Primary', packageJson: packageJson$1, layout: 'inline' },
		React.createElement(BaseActionButton, {
			innerRef: innerRef,
			isLoading: isLoading,
			labelText: labelText,
			loadingText: loadingText,
			onClick: onClick
		})
	);
};

Primary.propTypes = _extends$1({}, baseProps, {
	/** Button text. */
	labelText: PropTypes.string.isRequired
});

var Secondary = function Secondary(_ref2) {
	var innerRef = _ref2.innerRef,
	    isLoading = _ref2.isLoading,
	    labelText = _ref2.labelText,
	    loadingText = _ref2.loadingText,
	    onClick = _ref2.onClick;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Secondary', packageJson: packageJson$1, layout: 'inline' },
		React.createElement(BaseActionButton, {
			innerRef: innerRef,
			isLoading: isLoading,
			isSecondary: true,
			labelText: labelText,
			loadingText: loadingText,
			onClick: onClick
		})
	);
};

Secondary.propTypes = _extends$1({}, baseProps, {
	/** Button text. */
	labelText: PropTypes.string.isRequired
});

var UnwrappedAdd = function UnwrappedAdd(_ref3) {
	var innerRef = _ref3.innerRef,
	    isLoading = _ref3.isLoading,
	    labelText = _ref3.labelText,
	    loadingText = _ref3.loadingText,
	    onClick = _ref3.onClick,
	    theme = _ref3.theme;

	var PlusOutlineSmallIcon = getPlusOutlineLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Add', packageJson: packageJson$1, layout: 'inline' },
		React.createElement(BaseActionButton, {
			icon: React.createElement(PlusOutlineSmallIcon, null),
			innerRef: innerRef,
			isLoading: isLoading,
			isSecondary: true,
			labelText: labelText,
			loadingText: loadingText,
			onClick: onClick
		})
	);
};

UnwrappedAdd.propTypes = _extends$1({}, baseProps, {
	/** Button text. */
	labelText: PropTypes.string
});

UnwrappedAdd.defaultProps = {
	labelText: 'Add'
};

var Add = withTheme(UnwrappedAdd);

var UnwrappedRemove = function UnwrappedRemove(_ref4) {
	var innerRef = _ref4.innerRef,
	    isLoading = _ref4.isLoading,
	    labelText = _ref4.labelText,
	    loadingText = _ref4.loadingText,
	    onClick = _ref4.onClick,
	    theme = _ref4.theme;

	var CrossOutlineLargeIcon = getCrossOutlineLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Remove', packageJson: packageJson$1, layout: 'inline' },
		React.createElement(BaseActionButton, {
			icon: React.createElement(CrossOutlineLargeIcon, null),
			innerRef: innerRef,
			isLoading: isLoading,
			isSecondary: true,
			labelText: labelText,
			loadingText: loadingText,
			onClick: onClick
		})
	);
};

UnwrappedRemove.propTypes = _extends$1({}, baseProps, {
	/** Button text. */
	labelText: PropTypes.string
});

UnwrappedRemove.defaultProps = {
	labelText: 'Remove'
};

var Remove = withTheme(UnwrappedRemove);

var UnwrappedDownload = function UnwrappedDownload(_ref5) {
	var innerRef = _ref5.innerRef,
	    isLoading = _ref5.isLoading,
	    labelText = _ref5.labelText,
	    loadingText = _ref5.loadingText,
	    onClick = _ref5.onClick,
	    theme = _ref5.theme;

	var DownloadSolidLargeIcon = getDownloadSolidLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Download', packageJson: packageJson$1, layout: 'inline' },
		React.createElement(BaseActionButton, {
			icon: React.createElement(DownloadSolidLargeIcon, null),
			innerRef: innerRef,
			isLoading: isLoading,
			isSecondary: true,
			labelText: labelText,
			loadingText: loadingText,
			onClick: onClick
		})
	);
};

UnwrappedDownload.propTypes = _extends$1({}, baseProps, {
	/** Button text. */
	labelText: PropTypes.string
});

UnwrappedDownload.defaultProps = {
	labelText: 'Download'
};

var Download = withTheme(UnwrappedDownload);

var UnwrappedEdit = function UnwrappedEdit(_ref6) {
	var innerRef = _ref6.innerRef,
	    isLoading = _ref6.isLoading,
	    labelText = _ref6.labelText,
	    loadingText = _ref6.loadingText,
	    onClick = _ref6.onClick,
	    theme = _ref6.theme;

	var PencilOutlineLargeIcon = getPencilOutlineLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Edit', packageJson: packageJson$1, layout: 'inline' },
		React.createElement(BaseActionButton, {
			icon: React.createElement(PencilOutlineLargeIcon, null),
			innerRef: innerRef,
			isLoading: isLoading,
			isSecondary: true,
			labelText: labelText,
			loadingText: loadingText,
			onClick: onClick
		})
	);
};

UnwrappedEdit.propTypes = _extends$1({}, baseProps, {
	/** Button text. */
	labelText: PropTypes.string
});

UnwrappedEdit.defaultProps = {
	labelText: 'Edit'
};

var Edit = withTheme(UnwrappedEdit);

var UnwrappedFind = function UnwrappedFind(_ref7) {
	var innerRef = _ref7.innerRef,
	    isLoading = _ref7.isLoading,
	    labelText = _ref7.labelText,
	    loadingText = _ref7.loadingText,
	    onClick = _ref7.onClick,
	    theme = _ref7.theme;

	var MagnifySolidLargeIcon = getMagnifySolidLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Find', packageJson: packageJson$1, layout: 'inline' },
		React.createElement(BaseActionButton, {
			icon: React.createElement(MagnifySolidLargeIcon, null),
			innerRef: innerRef,
			isLoading: isLoading,
			labelText: labelText,
			loadingText: loadingText,
			onClick: onClick
		})
	);
};

UnwrappedFind.propTypes = _extends$1({}, baseProps, {
	/** Button text. */
	labelText: PropTypes.string
});

UnwrappedFind.defaultProps = {
	labelText: 'Find'
};

var Find = withTheme(UnwrappedFind);

var UnwrappedPrint = function UnwrappedPrint(_ref8) {
	var innerRef = _ref8.innerRef,
	    isLoading = _ref8.isLoading,
	    labelText = _ref8.labelText,
	    loadingText = _ref8.loadingText,
	    onClick = _ref8.onClick,
	    theme = _ref8.theme;

	var PrinterOutlineSmallIcon = getPrinterOutlineLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Print', packageJson: packageJson$1, layout: 'inline' },
		React.createElement(BaseActionButton, {
			icon: React.createElement(PrinterOutlineSmallIcon, null),
			innerRef: innerRef,
			isLoading: isLoading,
			isSecondary: true,
			labelText: labelText,
			loadingText: loadingText,
			onClick: onClick
		})
	);
};

UnwrappedPrint.propTypes = _extends$1({}, baseProps, {
	/** Button text. */
	labelText: PropTypes.string
});

UnwrappedPrint.defaultProps = {
	labelText: 'Print'
};

var Print = withTheme(UnwrappedPrint);

var UnwrappedSearch = function UnwrappedSearch(_ref9) {
	var innerRef = _ref9.innerRef,
	    isLoading = _ref9.isLoading,
	    labelText = _ref9.labelText,
	    loadingText = _ref9.loadingText,
	    onClick = _ref9.onClick,
	    theme = _ref9.theme;

	var MagnifySolidLargeIcon = getMagnifySolidLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Search', packageJson: packageJson$1, layout: 'inline' },
		React.createElement(BaseActionButton, {
			icon: React.createElement(MagnifySolidLargeIcon, null),
			innerRef: innerRef,
			isLoading: isLoading,
			isSecondary: true,
			labelText: labelText,
			loadingText: loadingText,
			onClick: onClick
		})
	);
};

UnwrappedSearch.propTypes = _extends$1({}, baseProps, {
	/** Button text. */
	labelText: PropTypes.string
});

UnwrappedSearch.defaultProps = {
	labelText: 'Search'
};

var Search = withTheme(UnwrappedSearch);

var UnwrappedUpload = function UnwrappedUpload(_ref10) {
	var innerRef = _ref10.innerRef,
	    isLoading = _ref10.isLoading,
	    labelText = _ref10.labelText,
	    loadingText = _ref10.loadingText,
	    onClick = _ref10.onClick,
	    theme = _ref10.theme;

	var UploadIcon = getUpload(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Upload', packageJson: packageJson$1, layout: 'inline' },
		React.createElement(BaseActionButton, {
			icon: React.createElement(UploadIcon, null),
			innerRef: innerRef,
			isLoading: isLoading,
			isSecondary: true,
			labelText: labelText,
			loadingText: loadingText,
			onClick: onClick,
			type: 'button'
		})
	);
};

UnwrappedUpload.propTypes = _extends$1({}, baseProps, {
	/** Button text. */
	labelText: PropTypes.string
});

UnwrappedUpload.defaultProps = {
	labelText: 'Upload'
};

var Upload = withTheme(UnwrappedUpload);

var ActionButton = {
	Primary: Primary,
	Secondary: Secondary,
	Add: Add,
	Download: Download,
	Edit: Edit,
	Find: Find,
	Print: Print,
	Remove: Remove,
	Search: Search,
	Upload: Upload
};

ActionButton.Primary.defaultExample = function () {
	return React.createElement(ActionButton.Primary, { labelText: 'Primary', onClick: function onClick() {} });
};

ActionButton.Secondary.defaultExample = function () {
	return React.createElement(ActionButton.Secondary, { labelText: 'Secondary', onClick: function onClick() {} });
};

ActionButton.Add.defaultExample = function () {
	return React.createElement(ActionButton.Add, { onClick: function onClick() {} });
};

ActionButton.Remove.defaultExample = function () {
	return React.createElement(ActionButton.Remove, { onClick: function onClick() {} });
};

ActionButton.Download.defaultExample = function () {
	return React.createElement(ActionButton.Download, { onClick: function onClick() {} });
};

ActionButton.Edit.defaultExample = function () {
	return React.createElement(ActionButton.Edit, { onClick: function onClick() {} });
};

ActionButton.Find.defaultExample = function () {
	return React.createElement(ActionButton.Find, { onClick: function onClick() {} });
};

ActionButton.Print.defaultExample = function () {
	return React.createElement(ActionButton.Print, { onClick: function onClick() {} });
};

ActionButton.Search.defaultExample = function () {
	return React.createElement(ActionButton.Search, { onClick: function onClick() {} });
};

ActionButton.Upload.defaultExample = function () {
	return React.createElement(ActionButton.Upload, { onClick: function onClick() {} });
};

export { ActionButton };
